(function(){'use strict';if(window.MGTracking)return;var seen=new WeakMap();var steps=new Set(['senderIdentity','storyIntro','trust','pronunciation','favoriteArtist','recipient','occasion','name','names','connection','additionalPeople','proof','genre','mood','moods','voice','perspective','language','details','story','summary','gate','offer','success']);function permitted(){try{var p=window.Shopify.customerPrivacy;return p.analyticsProcessingAllowed()===true&&p.marketingAllowed()===true&&p.saleOfDataAllowed()===true;}catch(_){return false;}}function send(root,name,step,hash){try{if(!permitted()||!window.Shopify.analytics||!window.Shopify.analytics.publish)return;var keys=seen.get(root);if(!keys){keys=new Set();seen.set(root,keys);}var key=name+':'+(step||'');if(keys.has(key))return;keys.add(key);var data={schema_version:1};if(steps.has(step))data.step_id=step;if(name==='mg_lead_saved'&&/^[a-f0-9]{64}$/.test(hash||''))data.match_email_sha256=hash;try{Promise.resolve(window.Shopify.analytics.publish(name,data)).catch(function(){keys.delete(key);});}catch(_){keys.delete(key);}}catch(_){}}async function lead(root,email){if(!permitted())return;var hash;try{var value=typeof email==='string'?email.trim().toLowerCase():'';if(value.length<=254&&/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)){var digest=await window.crypto.subtle.digest('SHA-256',new window.TextEncoder().encode(value));hash=Array.from(new Uint8Array(digest),function(b){return b.toString(16).padStart(2,'0');}).join('');}}catch(_){}send(root,'mg_lead_saved',undefined,hash);}function visible(root,node,name){if(!node||!window.IntersectionObserver)return;var observer=new window.IntersectionObserver(function(entries){if(entries.some(function(e){return e.isIntersecting&&e.intersectionRatio>=.25;})&&permitted()){send(root,name);observer.disconnect();}},{threshold:.25});observer.observe(node);}window.MGTracking={event:function(root,name,details){var step=details&&details.step_id;if(name==='mg_answer_select'||name==='mg_step_complete')send(root,'mg_funnel_started');if(name==='mg_step_complete'&&steps.has(step))send(root,'mg_step_completed',step);if(name==='mg_step_view'&&steps.has(step))send(root,'mg_step_viewed',step);if(name==='mg_step_view'&&step==='offer')visible(root,root.querySelector('[data-mg-offer-buybox] h3'),'mg_offer_viewed');if(name==='mg_lead_saved')return lead(root,details&&details.email);},preview:function(root,node){visible(root,node,'mg_preview_viewed');}};})();
(function () {
  'use strict';

  if (window.MelodyGlowThemeRuntime) {
    window.MelodyGlowThemeRuntime.init(document);
    return;
  }

  var SAFE_EVENT_FIELDS = ['step_id', 'total_steps', 'path', 'section_id', 'sample_index'];
  var FAMILY_ROLES = ['child', 'parent', 'sibling', 'grandparents'];

  function emit(root, eventName, details) {
    try { if (window.MGTracking) window.MGTracking.event(root, eventName, details); } catch (_) {}
    if (root.dataset.analyticsEnabled !== 'true') return;
    var safe = { event: eventName };
    SAFE_EVENT_FIELDS.forEach(function (key) {
      if (details && Object.prototype.hasOwnProperty.call(details, key)) safe[key] = details[key];
    });
    root.dispatchEvent(new CustomEvent('melodyglow:event', { bubbles: true, detail: safe }));
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // Horizon scrolls inside .page-wrapper on desktop, so window.scrollTo() is a no-op there.
  // scrollIntoView works for whichever element is the scroll container.
  function scrollToElement(element, block, instant) {
    if (!element) return;
    var behavior = instant || prefersReducedMotion() ? 'instant' : 'smooth';
    try { element.scrollIntoView({ behavior: behavior, block: block || 'start' }); }
    catch (ignore) { element.scrollIntoView(block !== 'end'); }
  }

  // Same output as Liquid's `money` filter, so prices look identical before and after JS updates them.
  function formatMoney(cents, format, locale, currency) {
    var value = Number(cents) || 0;
    var template = String(format || '').replace(/<[^>]*>/g, '');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = template.match(placeholder);
    function delimit(precision, thousands, decimal) {
      var parts = (value / 100).toFixed(precision).split('.');
      return parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands) + (parts[1] ? decimal + parts[1] : '');
    }
    var formats = {
      amount: [2, ',', '.'], amount_no_decimals: [0, ',', '.'],
      amount_with_comma_separator: [2, '.', ','], amount_no_decimals_with_comma_separator: [0, '.', ','],
      amount_with_apostrophe_separator: [2, "'", '.'], amount_with_space_separator: [2, ' ', ','],
      amount_no_decimals_with_space_separator: [0, ' ', '']
    };
    if (match && formats[match[1]]) return template.replace(placeholder, delimit.apply(null, formats[match[1]]));
    return new Intl.NumberFormat(locale || 'de-DE', { style: 'currency', currency: currency || 'EUR' }).format(value / 100);
  }
  window.MelodyGlowFormatMoney = formatMoney;

  function formatAudioTime(seconds) {
    if (!Number.isFinite(seconds) || seconds < 0) return '0:00';
    var minutes = Math.floor(seconds / 60);
    var remainder = Math.floor(seconds % 60);
    return minutes + ':' + String(remainder).padStart(2, '0');
  }

  function initAudios(scope) {
    scope.querySelectorAll('[data-mg-audio]:not([data-mg-ready])').forEach(function (audio, index) {
      audio.dataset.mgReady = 'true';
      var player = document.createElement('div');
      var compactUi = audio.dataset.mgAudioUi === 'compact' || Boolean(audio.closest('[data-mg-home]'));
      player.className = 'mg-audio-player' + (compactUi ? ' mg-audio-player--compact' : '');
      player.innerHTML = '<span class="mg-audio-cover" aria-hidden="true">♪</span><button class="mg-audio-toggle" type="button"><span aria-hidden="true">▶</span></button><label class="mg-audio-progress-wrap"><span class="visually-hidden">Audio position</span><input class="mg-audio-progress" type="range" min="0" max="1000" value="0" step="1"></label><span class="mg-audio-time">0:00</span>';
      audio.insertAdjacentElement('afterend', player);
      audio.controls = false;
      audio.classList.add('mg-audio-source');
      var toggle = player.querySelector('.mg-audio-toggle');
      var progress = player.querySelector('.mg-audio-progress');
      var time = player.querySelector('.mg-audio-time');
      var label = audio.getAttribute('aria-label') || 'Audio sample';
      toggle.setAttribute('aria-label', label);
      var audioEn=document.documentElement.lang.indexOf('en')===0;
      var errorNote=document.createElement('p');errorNote.className='mg-audio-error';errorNote.hidden=true;errorNote.setAttribute('role','status');errorNote.textContent=audioEn?'Could not play this sample. Press play to try again.':'Die Hörprobe konnte nicht abgespielt werden. Tippe auf Play, um es erneut zu versuchen.';player.insertAdjacentElement('afterend',errorNote);

      function syncPlayer() {
        var duration = Number(audio.duration || 0);
        var current = Number(audio.currentTime || 0);
        progress.value = duration > 0 ? String(Math.round((current / duration) * 1000)) : '0';
        time.textContent = formatAudioTime(current) + (duration > 0 ? ' / ' + formatAudioTime(duration) : '');
        toggle.querySelector('span').textContent = audio.paused ? '▶' : 'Ⅱ';
        player.classList.toggle('is-playing', !audio.paused);
      }

      toggle.addEventListener('click', function () {
        if (audio.paused) {
          if(player.classList.contains('is-error')){audio.load();player.classList.remove('is-error');errorNote.hidden=true;}
          var playPromise = audio.play();
          if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function () { player.classList.add('is-error'); errorNote.hidden=false; });
        } else audio.pause();
      });
      progress.addEventListener('input', function () {
        if (Number.isFinite(audio.duration) && audio.duration > 0) audio.currentTime = (Number(progress.value) / 1000) * audio.duration;
      });
      audio.addEventListener('loadedmetadata', syncPlayer);
      audio.addEventListener('timeupdate', syncPlayer);
      audio.addEventListener('pause', syncPlayer);
      audio.addEventListener('ended', syncPlayer);
      audio.addEventListener('error', function () {
        player.classList.add('is-error');
        toggle.disabled = false; errorNote.hidden=false;
        toggle.setAttribute('aria-label', label + (audioEn?' — retry':' — erneut versuchen'));
      });
      audio.addEventListener('play', function () {
        document.querySelectorAll('[data-mg-audio]').forEach(function (otherAudio) {
          if (otherAudio !== audio) otherAudio.pause();
        });
        syncPlayer();
        errorNote.hidden=true; player.classList.remove('is-error');
        var root = audio.closest('.mg-root');
        if (root) emit(root, 'mg_audio_play', { section_id: root.dataset.sectionId || '', sample_index: index + 1 });
      });
      syncPlayer();
    });
  }

  function formatReadyAt(node, hours) {
    var root = node.closest('[data-mg-locale]');
    var isEnglish = root && root.dataset.mgLocale === 'en';
    var locale = isEnglish ? 'en-GB' : 'de-DE';
    var now = new Date();
    var ready = new Date(now.getTime() + (Math.max(1, Number(hours) || 1) * 60 * 60 * 1000));
    var nowDay = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
    var readyDay = Date.UTC(ready.getFullYear(), ready.getMonth(), ready.getDate());
    var dayDifference = Math.round((readyDay - nowDay) / 86400000);
    var dayLabel = dayDifference === 0
      ? (isEnglish ? 'today' : 'heute')
      : dayDifference === 1
        ? (isEnglish ? 'tomorrow' : 'morgen')
        : new Intl.DateTimeFormat(locale, { weekday: 'short', day: '2-digit', month: '2-digit' }).format(ready);
    var timeLabel = new Intl.DateTimeFormat(locale, { hour: '2-digit', minute: '2-digit' }).format(ready);
    return isEnglish ? dayLabel + ' at ' + timeLabel : dayLabel + ', ' + timeLabel + ' Uhr';
  }

  function initDeliveryEstimates(scope) {
    scope.querySelectorAll('[data-mg-standard-ready]:not([data-mg-ready])').forEach(function (node) {
      node.dataset.mgReady = 'true';
      node.textContent = formatReadyAt(node, node.dataset.standardHours || 24);
    });
    scope.querySelectorAll('[data-mg-standard-delivery]:not([data-mg-ready])').forEach(function (node) {
      node.dataset.mgReady = 'true';
      var root = node.closest('[data-mg-locale]');
      var locale = root && root.dataset.mgLocale === 'en' ? 'en-GB' : 'de-DE';
      var days = Math.max(1, Number(node.dataset.deliveryDays || 3));
      var delivery = new Date();
      while (days > 0) {
        delivery.setDate(delivery.getDate() + 1);
        if (delivery.getDay() !== 0 && delivery.getDay() !== 6) days -= 1;
      }
      node.textContent = new Intl.DateTimeFormat(locale, { weekday: 'short', day: '2-digit', month: '2-digit' }).format(delivery);
    });
    scope.querySelectorAll('[data-mg-express-ready]:not([data-mg-ready])').forEach(function (node) {
      node.dataset.mgReady = 'true';
      node.textContent = formatReadyAt(node, node.dataset.expressHours || 2);
    });
  }

  function initCartProof(root) {
    if (root.dataset.mgCartProofReady === 'true') return;
    root.dataset.mgCartProofReady = 'true';
    var total = root.querySelector('[data-mg-cart-total]');
    if (!total) return;
    var timer = 0;
    function refreshTotal() {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' } })
          .then(function (response) { return response.ok ? response.json() : Promise.reject(new Error('cart')); })
          .then(function (cart) {
            total.textContent = new Intl.NumberFormat(root.dataset.mgLocale === 'en' ? 'en-GB' : 'de-DE', { style: 'currency', currency: cart.currency || 'EUR' }).format(Number(cart.total_price || 0) / 100);
          }).catch(function () {});
      }, 450);
    }
    var cartSection = document.querySelector('[id^="shopify-section-"][id$="cart-section"]');
    if (cartSection && window.MutationObserver) new MutationObserver(refreshTotal).observe(cartSection, { childList: true, subtree: true, characterData: true });
    document.addEventListener('cart:update', refreshTotal);
  }

  function initProduct(root) {
    if (root.dataset.mgProductReady === 'true') return;
    root.dataset.mgProductReady = 'true';
    var select = root.querySelector('[data-mg-variant-select]');
    var price = root.querySelector('[data-mg-product-price] strong');
    var links = root.querySelectorAll('[data-mg-configure-link]');
    if (!select) return;
    select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      if (price && option && option.dataset.price) price.textContent = option.dataset.price;
      links.forEach(function (link) {
        var url = new URL(link.href, window.location.origin);
        url.searchParams.set('variant', select.value);
        link.href = url.toString();
      });
      emit(root, 'mg_variant_change', { section_id: root.dataset.sectionId || '' });
    });
  }

  function initialState() {
    return {
      recipientRole: '', recipientRoleOther: '', occasion: '', occasionOther: '',
      recipientName: '', senderNames: '', pronunciation: '', connection: '', connectionOther: '',
      additionalPeople: [], genre: '', genreOther: '', moods: [], senderIdentity: '', voice: '', perspective: 'Ihr dürft entscheiden', language: '',
      languageOther: '', storyOrigin: '', keyMoments: '', traits: [], customTrait: '',
      coreMessage: '', mustInclude: '', mustAvoid: '', additionalNotes: '', favoriteArtist: '', lyricsMode: 'details', finishedLyrics: '',
      email: '', recoveryAccepted: false
    };
  }

  function cleanDraftState(raw) {
    var clean = initialState();
    if (!raw || typeof raw !== 'object') return clean;
    Object.keys(clean).forEach(function (key) {
      if (key === 'recoveryAccepted') return;
      if (key === 'email') return;
      if (Array.isArray(clean[key])) clean[key] = Array.isArray(raw[key]) ? raw[key].slice(0, key === 'additionalPeople' ? 4 : 5).map(String) : [];
      else if (typeof raw[key] === 'string') clean[key] = raw[key].slice(0, ['keyMoments', 'finishedLyrics'].indexOf(key) !== -1 ? 6000 : 1500);
    });
    return clean;
  }

  function makeRequestId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    var bytes = new Uint8Array(16);
    if (window.crypto && typeof window.crypto.getRandomValues === 'function') window.crypto.getRandomValues(bytes);
    else for (var index = 0; index < bytes.length; index += 1) bytes[index] = Math.floor(Math.random() * 256);
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    var hex = Array.prototype.map.call(bytes, function (byte) { return byte.toString(16).padStart(2, '0'); }).join('');
    return hex.slice(0, 8) + '-' + hex.slice(8, 12) + '-' + hex.slice(12, 16) + '-' + hex.slice(16, 20) + '-' + hex.slice(20);
  }

  function fetchWithTimeout(url, options, timeoutMs) {
    if (typeof window.AbortController !== 'function') return fetch(url, options);
    var controller = new AbortController();
    var timer = window.setTimeout(function () { controller.abort(); }, timeoutMs);
    var requestOptions = Object.assign({}, options, { signal: controller.signal });
    return fetch(url, requestOptions).finally(function () { window.clearTimeout(timer); });
  }

  function initConfigurator(root) {
    if (root.dataset.mgConfiguratorReady === 'true') return;
    root.dataset.mgConfiguratorReady = 'true';

    var isEnglish = root.dataset.mgLocale === 'en';
    function tr(de, en) { return isEnglish ? en : de; }
    function money(cents) { return formatMoney(cents, root.dataset.moneyFormat, isEnglish ? 'en-GB' : 'de-DE', root.dataset.currency); }
    var EN_LABELS = {
      'Weniger als ein Jahr': 'Less than one year', '1–3 Jahre': '1–3 years', '4–7 Jahre': '4–7 years',
      '8–15 Jahre': '8–15 years', 'Mehr als 15 Jahre': 'More than 15 years', 'Etwas anderes': 'Something else',
      'Baby oder Kleinkind': 'Baby or toddler', 'Schulkind': 'School-age child', 'Teenager': 'Teenager', 'Erwachsen': 'Adult',
      'Eng und vertraut': 'Close and familiar', 'Voller Dankbarkeit': 'Full of gratitude', 'Viele gemeinsame Jahre': 'Many years together',
      'Wir haben wieder zueinandergefunden': 'We found our way back to each other', 'Seit der Kindheit verbunden': 'Connected since childhood',
      'Durch Höhen und Tiefen': 'Through highs and lows', 'Viele Abenteuer erlebt': 'Shared many adventures', 'Derselbe Humor': 'The same sense of humour',
      'Familie im Herzen': 'Family at heart', 'Durch einen besonderen Moment verbunden': 'Connected by a special moment',
      'Schon viele Jahre': 'For many years', 'Ganz neu in meinem Leben': 'New in my life',
      'Weihnachten': 'Christmas', 'Geburtstag': 'Birthday', 'Hochzeit oder Jahrestag': 'Wedding or anniversary', 'Heiratsantrag': 'Marriage proposal',
      'Geburt oder Taufe': 'Birth or christening', 'Weihnachten': 'Christmas', 'Danke sagen': 'Say thank you',
      'Mut machen oder Trost schenken': 'Encouragement or comfort', 'Einfach so': 'Just because', 'Ein anderer Anlass': 'Another occasion',
      'Pop': 'Pop', 'Ballade': 'Ballad', 'House / Dance': 'House / Dance', 'Schlager': 'German pop',
      'R&B / Soul': 'R&B / Soul', 'Country / Folk': 'Country / Folk', 'Akustik': 'Acoustic',
      'Andere Musikrichtung': 'Another style', 'Ihr dürft entscheiden': 'You decide',
      'Gefühlvoller Deutschpop': 'Emotional German pop', 'Piano-Ballade': 'Piano ballad', 'Moderner Schlager': 'Modern German pop',
      'Rock': 'Rock', 'Rap': 'Rap', 'Überrascht mich': 'Surprise me', 'Tief berührend': 'Deeply moving',
      'Fröhlich': 'Joyful', 'Warm & geborgen': 'Warm & safe', 'Romantisch': 'Romantic', 'Nostalgisch': 'Nostalgic',
      'Leicht & verspielt': 'Light & playful', 'Kraftvoll': 'Powerful', 'Ruhig': 'Calm', 'Hoffnungsvoll': 'Hopeful',
      'Weibliche Stimme': 'Female voice', 'Männliche Stimme': 'Male voice', 'Beide Stimmen': 'Both voices', 'Ihr dürft entscheiden': 'You decide',
      'Direkt mit du': 'Directly using “you”', 'Über die Person erzählt': 'Told about the person',
      'Aus unserer wir-Perspektive': 'From our “we” perspective', 'Deutsch': 'German', 'Englisch': 'English',
      'Deutsch & Englisch gemischt': 'German & English mixed', 'Andere Sprache': 'Another language',
      'Herzlich': 'Warm-hearted', 'Humorvoll': 'Funny', 'Mutig': 'Brave', 'Verlässlich': 'Reliable',
      'Lebensfroh': 'Full of life', 'Kreativ': 'Creative', 'Für andere da': 'Always there for others',
      'Ein bisschen chaotisch': 'A little chaotic', 'Etwas Eigenes': 'Something else'
    };
    function localizedLabel(value) { return isEnglish ? (EN_LABELS[value] || value) : value; }

    var intro = root.querySelector('[data-mg-intro]');
    var flow = root.querySelector('[data-mg-flow]');
    var form = root.querySelector('[data-mg-briefing-form]');
    var startButton = root.querySelector('[data-mg-start]');
    var resetButton = root.querySelector('[data-mg-reset]');
    var discardPendingButton = root.querySelector('[data-mg-discard-pending]');
    var editProfileButtons = root.querySelectorAll('[data-mg-edit-profile]');
    var jumpOfferButtons = root.querySelectorAll('[data-mg-jump-offer]');
    var saveButton = root.querySelector('[data-mg-save]');
    var submitButton = root.querySelector('[data-mg-submit]');
    var submitButtonMarkup=submitButton.innerHTML;
    var offerOnlyButton = root.querySelector('[data-mg-offer-only]');
    var checkoutButton = root.querySelector('[data-mg-checkout]');
    var checkoutButtons = root.querySelectorAll('[data-mg-checkout], [data-mg-checkout-sticky]');
    var nextButton = root.querySelector('[data-mg-next]');
    var backButton = root.querySelector('[data-mg-back]');
    var nav = root.querySelector('[data-mg-nav]');
    var errorBox = root.querySelector('[data-mg-error]');
    var phaseLabel = root.querySelector('[data-mg-phase]');
    var counterLabel = root.querySelector('[data-mg-counter]');
    var progressBar = root.querySelector('[data-mg-progress]');
    var progressWrap = root.querySelector('.mg-progress');
    var draftKey = root.dataset.draftKey || 'melodyglow-song-draft-v3';
    var pendingCartKey = draftKey + '-pending-cart';
var verifiedRecoveryCredit=null;
function activeCreditCents(){var c=verifiedRecoveryCredit;return c&&c.configuration_id===savedConfigurationId&&String(c.product_variant_id)===String(pendingVariantId)&&c.currency===root.dataset.currency&&c.amount_cents===1276&&/^MG1276-[A-Z0-9]{30}$/.test(c.code||'')&&Date.parse(c.expires_at)>Date.now()?Math.min(c.amount_cents,Number(root.dataset.basePriceCents)||0):0;}
function renderOfferSavings(){
var base=Number(root.dataset.basePriceCents),credit=activeCreditCents(),sale=root.dataset.currency==='EUR'&&base>0&&base<9995;
root.dataset.mgCreditCents=String(credit);
var oldNote=root.querySelector('[data-mg-savings-note]');if(oldNote)oldNote.remove();
var row=root.querySelector('[data-mg-order-overview] .mg-total-row');
if(row){
var banner=root.querySelector('[data-mg-sale-banner]');
if(!banner){banner=document.createElement('div');banner.setAttribute('data-mg-sale-banner','');banner.style.cssText='display:flex;align-items:center;justify-content:space-between;gap:16px;padding:16px 20px;margin:16px 0;border-radius:14px;background:linear-gradient(110deg,#542044,#813960);color:#fff';var copy=document.createElement('div');var label=document.createElement('small');label.textContent=tr('MELODYGLOW ANGEBOT','MELODYGLOW OFFER');label.style.cssText='display:block;font-size:10px;letter-spacing:.12em;font-weight:600;color:#f2dce9';var title=document.createElement('strong');title.setAttribute('data-mg-sale-amount','');title.style.cssText='display:block;font-size:24px;line-height:1.25;margin:3px 0;color:#fff';var sub=document.createElement('span');sub.textContent=tr('auf deinen persönlichen Song','on your personal song');sub.style.cssText='font-size:13px;color:#f2dce9';copy.append(label,title,sub);var icon=document.createElement('span');icon.textContent='♫';icon.setAttribute('aria-hidden','true');icon.style.cssText='font-size:48px;line-height:1;color:#eccddf;padding:0 4px;transform:rotate(-10deg)';banner.append(copy,icon);row.before(banner);}
banner.hidden=!sale;banner.style.display=sale?'flex':'none';if(sale)banner.querySelector('[data-mg-sale-amount]').textContent=new Intl.NumberFormat(isEnglish?'en-GB':'de-DE',{style:'currency',currency:'EUR',maximumFractionDigits:0}).format((9995-base)/100)+tr(' Rabatt',' off');
var old=row.querySelector('[data-mg-regular-total]');if(!old){old=document.createElement('del');old.setAttribute('data-mg-regular-total','');old.style.cssText='font-size:14px;font-weight:400;color:#8b7c84;white-space:nowrap;margin-left:auto;margin-right:10px';row.insertBefore(old,row.querySelector('[data-mg-offer-total]'));}old.hidden=!sale;if(sale)old.textContent=money(9995+selectedOfferAddons().reduce(function(sum,a){return sum+a.cents;},0));
}
root.dispatchEvent(new CustomEvent('mg:price-updated'));
}

    var draftEnabled = root.dataset.draftEnabled === 'true';
    var draftMaxAge = 14 * 24 * 60 * 60 * 1000;
    var state = initialState();
    var currentId = 'recipient';
    var started = false;
    var requestId = makeRequestId();
    var savedConfigurationId = '';
    var intakeAttempted = false;
    var cartAttemptedAt = 0;
    var briefingLocked = false;
    var pendingVariantId = '';
    var submitInFlight = false;
    var autoAdvanceTimer = 0;
    var detailsNudgeShown = false;

    var anonymousPreviewPromise = null, anonymousPreviewReceipt = null, anonymousPreviewKey = '', anonymousPreviewTimer = null, anonymousSubmitWaiting = false;
    function anonymousProfile() {
      var profile = webhookPayload(selectedVariantId()); delete profile.email; return profile;
    }
    function startAnonymousPreview() {
      if (anonymousPreviewTimer) window.clearTimeout(anonymousPreviewTimer);
      if (savedConfigurationId || currentId !== 'gate') return;
      var gate = root.querySelector('[data-step="gate"]');
      if (gate && !gate.querySelector('[data-mg-preview-notice]')) {
        var note=document.createElement('p'); note.setAttribute('data-mg-preview-notice',''); note.className='mg-privacy-note';
        note.textContent=tr('✨ Während du deine E-Mail eingibst, schreiben wir schon die ersten Zeilen deines Songtexts – du siehst sie gleich im Angebot. Ohne Fortfahren wird die Vorschau nur kurzzeitig gespeichert.', '✨ While you enter your email, we are already writing the first lines of your lyrics – you will see them in your offer. If you do not continue, the preview is stored only briefly.');
        var field=gate.querySelector('.mg-field-group'); if(field)field.insertBefore(note,field.firstChild);
      }
      var profile=anonymousProfile(),key=JSON.stringify(profile);
      if (anonymousPreviewKey === key && (anonymousPreviewPromise || anonymousPreviewReceipt)) return;
      if (anonymousPreviewPromise) return;
      var deadline=Date.now()+30000;
      function attempt() {
        if (currentId !== 'gate' || savedConfigurationId || submitInFlight || anonymousSubmitWaiting) return;
        var field=root.querySelector('[name="cf-turnstile-response"]'),token=field?String(field.value||'').trim():'';
        if (!token) { if(Date.now()<deadline)anonymousPreviewTimer=window.setTimeout(attempt,300); return; }
        anonymousPreviewKey=key; anonymousPreviewReceipt=null;
        anonymousPreviewPromise=(async function(){
          try {
            var response=await fetchWithTimeout('https://songs.melodyglow.com/api/lyric-preview/start',{method:'POST',mode:'cors',credentials:'omit',headers:{'Content-Type':'application/json','CF-Turnstile-Response':token},body:JSON.stringify(profile)},25000);
            var result=await response.json();
            if(response.ok && result.status==='ready' && result.receipt && anonymousPreviewKey===key)anonymousPreviewReceipt=result.receipt;
          } catch(ignore) {} finally {
            anonymousPreviewPromise=null;
            // The challenge token was consumed; refresh for any changed-profile fallback.
            resetTurnstile();
          }
        })();
      }
      attempt();
    }
    async function finishAnonymousPreview() {
      if(anonymousPreviewPromise)await anonymousPreviewPromise;
      var receipt=anonymousPreviewKey===JSON.stringify(anonymousProfile())?anonymousPreviewReceipt:null;
      if(!receipt && anonymousPreviewKey && root.dataset.turnstileEnabled==='true') {
        var until=Date.now()+8000;
        while(Date.now()<until) {
          var field=root.querySelector('[name="cf-turnstile-response"]');
          if(field && String(field.value||'').trim())break;
          await new Promise(function(resolve){window.setTimeout(resolve,200);});
        }
      }
      return receipt;
    }

    var lyricPreviewAccess = null;
    var lyricPreviewActiveId = '';
    var offerPreviewStatus='idle';
    function previewBox() {
      var box = root.querySelector('[data-mg-lyric-preview]');
      if (box) return box;
      var offer = root.querySelector('[data-step="offer"]');
      var target = offer && (offer.querySelector('.mg-lyric-preview') || offer.querySelector('[data-mg-offer-buybox]'));
      if (!target) return null;
      box = document.createElement('section'); box.setAttribute('data-mg-lyric-preview', '');
      box.setAttribute('aria-live', 'polite');
      box.style.cssText = 'margin:0;padding:24px;border:1px solid #e6d5df;border-radius:18px;background:#fffaf5;color:#36152f;';
      target.parentNode.insertBefore(box, target);
      if (target.classList.contains('mg-lyric-preview')) target.style.display = 'none';
      return box;
    }
    function showPreviewState(message, verses) {
  var box=previewBox();if(!box)return;
  if(verses)offerPreviewStatus='ready';
  box.dataset.state=offerPreviewStatus;box.replaceChildren();
  var title=document.createElement('h3');title.textContent=tr('Ein erster Einblick in deinen Songtext','A first look at your lyrics');box.appendChild(title);
  if(verses)verses.forEach(function(lines){var p=document.createElement('p');p.className='mg-preview-verse';p.textContent=lines.join('\n');box.appendChild(p);});
  var note=document.createElement('p');note.className='mg-preview-note';note.textContent=verses?tr('Diese Vorschau basiert auf deinen Angaben. Dein vollständiger Song entsteht nach der Bestellung.','This preview is based on your details. Your full song is created after ordering.'):message;box.appendChild(note);
  if (verses && verses.length) { try { if (window.MGTracking) window.MGTracking.preview(root, box.querySelector(".mg-preview-verse")); } catch (_) {} }
  if(offerPreviewStatus==='error'){var retry=document.createElement('button');retry.type='button';retry.className='mg-text-button';retry.textContent=tr('Erneut versuchen','Try again');retry.addEventListener('click',function(){lyricPreviewActiveId='';requestLyricPreview();});box.appendChild(retry);}
  if(typeof syncOfferSticky==='function')syncOfferSticky();
}

    async function requestLyricPreview() {
      if (!lyricPreviewAccess || lyricPreviewAccess.configuration_id !== savedConfigurationId || lyricPreviewActiveId === savedConfigurationId) return;
      var access = lyricPreviewAccess, activeId = savedConfigurationId; lyricPreviewActiveId = activeId; offerPreviewStatus='loading';
      showPreviewState(tr('Deine persönliche Vorschau wird erstellt …', 'Your personal preview is being created …'));
      try {
        for (var attempt = 0; attempt < 18; attempt++) {
          var response = await fetchWithTimeout('https://songs.melodyglow.com/api/lyric-preview', {method:'POST',mode:'cors',credentials:'omit',headers:{'Content-Type':'application/json'},body:JSON.stringify(access)}, 65000);
          var result = await response.json(); if (savedConfigurationId !== activeId) return;
          if (!response.ok) throw new Error('preview_unavailable');
          if (result.status === 'ready' && result.preview && Array.isArray(result.preview.verses)) {
            showPreviewState(result.preview.source === 'supplied' ? tr('Ein Ausschnitt aus deinem eigenen Songtext. Nach dem Kauf verwenden wir deinen eingereichten Text.', 'An excerpt from your own lyrics. After purchase we use your submitted text.') : tr('Deine ersten Strophen. Nur für euch.', 'Your first verses. Just for you.'), result.preview.verses); return;
          }
          if (result.status !== 'generating') throw new Error('preview_unavailable');
          await new Promise(function(resolve){window.setTimeout(resolve,4000);});
        }
        throw new Error('preview_timeout');
      } catch(ignore) {
        if (savedConfigurationId === activeId) { offerPreviewStatus='error'; showPreviewState(tr('Die Vorschau konnte gerade nicht geladen werden. Deine Angaben sind gespeichert. Du kannst trotzdem bestellen.', 'The preview could not be loaded. Your details are saved and you can still order.')); }
      }
    }

    function savePendingCart() {
      if (!savedConfigurationId || !pendingVariantId) return;
      try {
        window.localStorage.setItem(pendingCartKey, JSON.stringify({
          selected_addon_ids: selectedOfferAddons().map(function(x){return x.id;}),
          lyric_preview_access: lyricPreviewAccess,
          configuration_id: savedConfigurationId,
          variant_id: pendingVariantId,
          cart_attempted_at: cartAttemptedAt,
          saved_at: Date.now()
        }));
      } catch (ignore) {}
    }

    function clearPendingCart() {
      try { window.localStorage.removeItem(pendingCartKey); } catch (ignore) {}
    }

    function restorePendingCart() {
      try {
        var raw = window.localStorage.getItem(pendingCartKey);
        if (!raw) return false;
        var pending = JSON.parse(raw);
        if (!pending || !/^mg_[0-9a-f]{32}$/.test(String(pending.configuration_id || '')) || !/^\d{6,20}$/.test(String(pending.variant_id || '')) || !Number.isFinite(Number(pending.saved_at)) || Date.now() - Number(pending.saved_at) > draftMaxAge) {
          clearPendingCart(); return false;
        }
        lyricPreviewAccess = pending.lyric_preview_access || null;
        savedConfigurationId = String(pending.configuration_id);
        pendingVariantId = String(pending.variant_id);
        cartAttemptedAt = Math.max(0, Number(pending.cart_attempted_at) || 0);
        if(Array.isArray(pending.selected_addon_ids)) root.querySelectorAll('[data-mg-addon]').forEach(function(input){input.checked=pending.selected_addon_ids.indexOf(String(input.value))!==-1;});
        currentId = 'offer';
        started = true;
        setBriefingLocked(true);
        return true;
      } catch (ignore) {
        clearPendingCart(); return false;
      }
    }

    function resetTurnstile() {
      if (root.dataset.turnstileEnabled === 'true' && window.turnstile && typeof window.turnstile.reset === 'function') {
        try { window.turnstile.reset(); } catch (ignore) {}
      }
    }

    function syncBriefingLock() {
      root.querySelectorAll('[data-field], [data-choice], [data-multi], [data-add-person], [data-remove-person]').forEach(function (control) {
        if (briefingLocked) control.disabled = true;
        else if (!control.hasAttribute('data-multi')) control.disabled = false;
      });
      root.querySelectorAll('[data-mg-addon],[data-mg-package]').forEach(function(control){control.disabled=submitInFlight;});
      backButton.disabled = briefingLocked;
      if (briefingLocked) backButton.setAttribute('aria-disabled', 'true'); else backButton.removeAttribute('aria-disabled');
      var lockedNote = root.querySelector('[data-mg-locked-note]');
      if (lockedNote) lockedNote.hidden = !briefingLocked;
      if (discardPendingButton) {
        discardPendingButton.hidden = !briefingLocked;
        discardPendingButton.disabled = submitInFlight;
      }
    }

    function setBriefingLocked(locked) {
      briefingLocked = locked === true;
      syncBriefingLock();
    }

    function markBriefingChanged() {
      if (briefingLocked) return false;
      if (intakeAttempted) {
        requestId = makeRequestId();
        intakeAttempted = false;
        cartAttemptedAt = 0;
        resetTurnstile();
      }
      return true;
    }

    function isFamily() { return FAMILY_ROLES.indexOf(state.recipientRole) !== -1; }
    function pathName() { return isFamily() ? 'family' : 'standard'; }
    function normalizeDependentState() {
      if (state.recipientRole !== 'other') state.recipientRoleOther = '';
      if (!isFamily()) state.additionalPeople = [];
      if (state.occasion !== 'Ein anderer Anlass') state.occasionOther = '';
      if (state.connection !== 'Etwas anderes') state.connectionOther = '';
      if (state.genre !== 'Andere Musikrichtung') state.genreOther = '';
      if (state.language !== 'Andere Sprache') state.languageOther = '';
      if (state.traits.indexOf('Etwas Eigenes') === -1) state.customTrait = '';
    }
    function sequence() {
      return ['recipient', 'occasion', 'genre', 'voice', 'details'];
    }
    function questionIds() {
      return sequence().filter(function (id) {
        var panel = root.querySelector('[data-step="' + id + '"]');
        return panel && panel.dataset.kind === 'question';
      });
    }

    function totalStepCount() { return questionIds().length + 1; }

    function isAutomaticChoiceStep(id) {
      return false; // Keep answer selection separate from moving to the next question.
    }

    function choiceNeedsDetails(id) {
      if (id === 'recipient') return state.recipientRole === 'other';
      if (id === 'genre') return state.genre === 'Andere Musikrichtung';
      if (id === 'occasion') return state.occasion === 'Ein anderer Anlass';
      if (id === 'connection') return state.connection === 'Etwas anderes';
      if (id === 'language') return state.language === 'Andere Sprache';
      return false;
    }

    function syncNavigation() {
      var terminal = ['gate', 'loading', 'offer', 'success'].indexOf(currentId) !== -1;
      var automatic = isAutomaticChoiceStep(currentId) && !choiceNeedsDetails(currentId);
      nextButton.hidden = terminal || currentId === 'summary' || automatic;
      backButton.hidden = (terminal && currentId !== 'gate') || currentId === 'recipient';
      nav.hidden = (terminal && currentId !== 'gate') || (nextButton.hidden && backButton.hidden);
      nav.classList.toggle('mg-config-nav--static', currentId === 'gate');
      var optional = ['details', 'pronunciation', 'favoriteArtist'].indexOf(currentId) !== -1;
      nextButton.textContent = tr('Weiter →', 'Continue →');
    }

    function scheduleAutomaticAdvance(stepId) {
      window.clearTimeout(autoAdvanceTimer);
      if (!isAutomaticChoiceStep(stepId) || choiceNeedsDetails(stepId)) {
        syncNavigation();
        return;
      }
      autoAdvanceTimer = window.setTimeout(function () {
        if (currentId === stepId && !briefingLocked) next();
      }, 180);
    }

    function saveDraft() {
      if (!draftEnabled || !started || currentId === 'success') return;
      var localState = Object.assign({}, state, { email: '', recoveryAccepted: false });
      try { window.localStorage.setItem(draftKey, JSON.stringify({ state: localState, currentId: currentId, requestId: requestId, savedAt: Date.now() })); } catch (ignore) {}
    }

    function restoreDraft() {
      if (!draftEnabled) return false;
      try {
        var raw = window.localStorage.getItem(draftKey);
        if (!raw) return false;
        var parsed = JSON.parse(raw);
        if (!Number.isFinite(Number(parsed.savedAt)) || Date.now() - Number(parsed.savedAt) > draftMaxAge) {
          window.localStorage.removeItem(draftKey); return false;
        }
        state = cleanDraftState(parsed.state);
        normalizeDependentState();
        currentId = typeof parsed.currentId === 'string' ? parsed.currentId : 'recipient';
        if (['loading', 'offer', 'success'].indexOf(currentId) !== -1) currentId = 'gate';
        requestId = typeof parsed.requestId === 'string' && /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(parsed.requestId) ? parsed.requestId : makeRequestId();
        return true;
      } catch (ignore) {
        try { window.localStorage.removeItem(draftKey); } catch (ignored) {}
        return false;
      }
    }

    function resetState() {
      state = initialState();
      state.language = '';
      currentId = 'recipient';
      requestId = makeRequestId();
      savedConfigurationId = '';
      intakeAttempted = false;
      cartAttemptedAt = 0;
      pendingVariantId = '';
      clearPendingCart();
      setBriefingLocked(false);
      root.querySelectorAll('[data-mg-addon]').forEach(function (input) { input.checked = false; });
      updateOfferTotal();
      if (draftEnabled) {
        try { window.localStorage.removeItem(draftKey); } catch (ignore) {}
      }
      syncAllFields();
    }

    // Errors appear next to the question or button they belong to instead of below the whole step.
    var ERROR_ANCHORS = {
      recipient: '[data-step="recipient"] > .mg-options',
      names: '[data-mg-question="names"]',
      occasion: '[data-step="occasion"] > .mg-options',
      connection: '[data-mg-question="connection"]',
      language: '[data-mg-question="language"]',
      details: '[data-step="details"] .mg-story-tools',
      finishedLyrics: '[data-show-when="lyricsMode:finishedLyrics"]'
    };
    var ERROR_FOCUS = { names: '[data-field="recipientName"]', finishedLyrics: '[data-field="finishedLyrics"]' };
    function setError(message, anchorKey, isHint) {
      root.querySelectorAll('[aria-invalid="true"]').forEach(function (field) { field.removeAttribute('aria-invalid'); });
      if (!message) { errorBox.hidden = true; errorBox.textContent = ''; errorBox.classList.remove('is-hint'); return; }
      var anchor = anchorKey && ERROR_ANCHORS[anchorKey] ? root.querySelector(ERROR_ANCHORS[anchorKey]) : null;
      if (!anchor && currentId === 'gate') anchor = root.querySelector('[data-mg-offer-only]') || submitButton;
      if (!anchor && currentId === 'offer') anchor = checkoutButton;
      if (anchor && anchor.offsetParent !== null) anchor.insertAdjacentElement('afterend', errorBox);
      else form.insertBefore(errorBox, nav);
      errorBox.textContent = message;
      errorBox.classList.toggle('is-hint', isHint === true);
      errorBox.hidden = false;
      var field = anchorKey && ERROR_FOCUS[anchorKey] ? root.querySelector(ERROR_FOCUS[anchorKey]) : null;
      if (field) { field.setAttribute('aria-invalid', 'true'); try { field.focus({ preventScroll: true }); } catch (ignore) {} }
      scrollToElement(errorBox, 'center');
    }

    function renderConnectionOptions() {
      var target = root.querySelector('[data-connection-options]');
      if (!target) return;
      var options;
      if (state.recipientRole === 'partner') options = ['Weniger als ein Jahr', '1–3 Jahre', '4–7 Jahre', '8–15 Jahre', 'Mehr als 15 Jahre', 'Etwas anderes'];
      else if (state.recipientRole === 'child') options = ['Baby oder Kleinkind', 'Schulkind', 'Teenager', 'Erwachsen'];
      else if (state.recipientRole === 'parent' || state.recipientRole === 'grandparents') options = ['Eng und vertraut', 'Voller Dankbarkeit', 'Viele gemeinsame Jahre', 'Wir haben wieder zueinandergefunden', 'Etwas anderes'];
      else if (state.recipientRole === 'sibling' || state.recipientRole === 'friend') options = ['Seit der Kindheit verbunden', 'Durch Höhen und Tiefen', 'Viele Abenteuer erlebt', 'Derselbe Humor', 'Familie im Herzen', 'Etwas anderes'];
      else options = ['Eng und vertraut', 'Durch einen besonderen Moment verbunden', 'Schon viele Jahre', 'Ganz neu in meinem Leben', 'Etwas anderes'];
      if (options.indexOf(state.connection) === -1) { state.connection = ''; state.connectionOther = ''; }
      target.textContent = '';
      options.forEach(function (label) {
        var button = document.createElement('button');
        button.type = 'button'; button.className = 'mg-choice'; button.dataset.choice = 'connection'; button.dataset.value = label; button.textContent = localizedLabel(label);
        if (state.connection === label) button.classList.add('is-selected');
        button.setAttribute('aria-pressed', state.connection === label ? 'true' : 'false');
        target.appendChild(button);
      });
      var title = root.querySelector('[data-mg-connection-title]');
      if (title) title.textContent = state.recipientRole === 'child'
        ? tr('In welcher Lebensphase ist ' + (state.recipientName || 'dieses Kind') + ' gerade?', 'What stage of life is ' + (state.recipientName || 'this child') + ' currently in?')
        : state.recipientRole === 'partner'
          ? tr('Wie lange seid ihr schon zusammen?', 'How long have you been together?')
          : tr('Was beschreibt eure Verbindung am besten?', 'What best describes your relationship?');
    }

    function renderPeople() {
      var list = root.querySelector('[data-people-list]');
      var add = root.querySelector('[data-add-person]');
      if (!list) return;
      list.textContent = '';
      state.additionalPeople.forEach(function (person, index) {
        var row = document.createElement('div'); row.className = 'mg-person-row';
        var input = document.createElement('input'); input.className = 'mg-field'; input.type = 'text'; input.maxLength = 60; input.placeholder = tr('Weitere Person ', 'Additional person ') + (index + 1); input.value = person; input.dataset.personIndex = String(index); input.setAttribute('aria-label', tr('Name der weiteren Person ', 'Name of additional person ') + (index + 1));
        var remove = document.createElement('button'); remove.className = 'mg-icon-button'; remove.type = 'button'; remove.dataset.removePerson = String(index); remove.setAttribute('aria-label', tr('Person ' + (index + 1) + ' entfernen', 'Remove person ' + (index + 1))); remove.textContent = '×';
        row.appendChild(input); row.appendChild(remove); list.appendChild(row);
      });
      if (add) add.hidden = state.additionalPeople.length >= 4;
    }

    function syncConditionals() {
      root.querySelectorAll('[data-show-when]').forEach(function (node) {
        var pieces = node.dataset.showWhen.split(':');
        node.hidden = state[pieces[0]] !== pieces.slice(1).join(':');
      });
      root.querySelectorAll('[data-show-array]').forEach(function (node) {
        var pieces = node.dataset.showArray.split(':');
        node.hidden = !Array.isArray(state[pieces[0]]) || state[pieces[0]].indexOf(pieces.slice(1).join(':')) === -1;
      });
    }

    function syncChoices() {
      root.querySelectorAll('[data-choice]').forEach(function (button) {
        var selected = state[button.dataset.choice] === button.dataset.value;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      root.querySelectorAll('[data-multi]').forEach(function (button) {
        var values = state[button.dataset.multi] || [];
        var active = values.indexOf(button.dataset.value) !== -1;
        var max = Number(button.dataset.max || 99);
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
        button.disabled = !active && values.length >= max;
      });
      root.querySelectorAll('[data-multi-count]').forEach(function (node) {
        var key = node.dataset.multiCount; var max = key === 'moods' ? 3 : 5;
        node.textContent = isEnglish ? (state[key] || []).length + ' of up to ' + max + ' selected' : (state[key] || []).length + ' von maximal ' + max + ' ausgewählt';
      });
    }

    function syncFields() {
      root.querySelectorAll('[data-field]').forEach(function (field) {
        var key = field.dataset.field;
        if (field.type === 'checkbox') field.checked = Boolean(state[key]);
        else if (document.activeElement !== field) field.value = state[key] || '';
      });
      root.querySelectorAll('[data-char-count]').forEach(function (node) {
        var key = node.dataset.charCount; var max = key === 'finishedLyrics' ? 6000 : (key === 'storyOrigin' || key === 'keyMoments') ? 5000 : 3000;
        node.textContent = String((state[key] || '').length).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' / ' + String(max).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      });
      var name = state.recipientName || tr('diesen Menschen', 'this person');
      var storyTitle = root.querySelector('[data-story-title]');
      var traitsTitle = root.querySelector('[data-traits-title]');
      var messageTitle = root.querySelector('[data-message-title]');
      if (storyTitle) storyTitle.textContent = tr('Jetzt fehlen die Momente, die nur ihr kennt', 'Now we need the moments only you know') + (state.recipientName ? ', ' + state.recipientName : '') + '.';
      if (traitsTitle) traitsTitle.textContent = tr('Was ist typisch für ', 'What is typical of ') + name + '?';
      if (messageTitle) messageTitle.textContent = tr('Was soll ', 'What should ') + name + tr(' nach dem letzten Ton wissen?', ' know after the final note?');
      var possessive = !state.recipientName ? tr('Dein', 'Your')
        : isEnglish ? state.recipientName + (/s$/i.test(state.recipientName) ? '’' : '’s')
        : state.recipientName + (/[sxzß]$/i.test(state.recipientName) ? '’' : 's');
      var summaryLine = root.querySelector('[data-mg-summary-line]');
      if (summaryLine) {
        var summaryParts = [];
        if (state.recipientName.trim()) summaryParts.push(tr('Für ', 'For ') + state.recipientName.trim());
        if (state.occasion) summaryParts.push(state.occasion === 'Ein anderer Anlass' && state.occasionOther.trim() ? state.occasionOther.trim() : localizedLabel(state.occasion));
        if (state.genre && state.genre !== 'Ihr dürft entscheiden') summaryParts.push(state.genre === 'Andere Musikrichtung' && state.genreOther.trim() ? state.genreOther.trim() : localizedLabel(state.genre));
        summaryLine.textContent = summaryParts.join(' · ');
        summaryLine.hidden = !summaryParts.length || ['loading', 'offer', 'success'].indexOf(currentId) !== -1;
      }
      var storyMeter = root.querySelector('[data-mg-story-meter]');
      if (storyMeter) {
        var storyLength = state.keyMoments.trim().length;
        var storyLevel = storyLength === 0 ? 0 : storyLength < 60 ? 1 : storyLength < 160 ? 2 : 3;
        storyMeter.dataset.level = String(storyLevel);
        if (detailsNudgeShown && currentId === 'details') nextButton.textContent = storyLength >= 20 ? tr('Weiter →', 'Continue →') : tr('Ohne weitere Details weiter →', 'Continue without more details →');
        var storyMeterText = storyMeter.querySelector('[data-mg-story-meter-text]');
        if (storyMeterText) storyMeterText.textContent = [
          tr('Tipp: Schon 2–3 Stichpunkte machen den Song deutlich persönlicher.', 'Tip: just 2–3 notes make the song much more personal.'),
          tr('Guter Anfang! Ein konkretes Detail – ein Ort, ein Insider, ein Satz – macht den Unterschied.', 'Good start! One concrete detail – a place, an inside joke, a phrase – makes the difference.'),
          tr('Sehr schön – noch eine Erinnerung, und der Song wird unverwechselbar.', 'Lovely – one more memory and the song becomes unmistakably yours.'),
          tr('Perfekt – daraus lässt sich ein sehr persönlicher Song schreiben.', 'Perfect – that is plenty for a truly personal song.')
        ][storyLevel];
      }
      var detailsTitle = root.querySelector('[data-details-title]');
      var loadingTitle = root.querySelector('[data-loading-title]');
      var emailTitle = root.querySelector('[data-email-title]');
      var offerTitle = root.querySelector('[data-offer-title]');
      var offerEmail = root.querySelector('[data-offer-email]');
      if (detailsTitle) detailsTitle.textContent = state.recipientName ? tr('Was soll in ' + possessive + ' Song vorkommen?', 'What should be part of ' + possessive + ' song?') : tr('Welche Details sollen im Song vorkommen?', 'What details should be part of the song?');
      if (loadingTitle) loadingTitle.textContent = state.recipientName ? tr('Wir ordnen gerade ' + possessive + ' Songprofil …', 'We are arranging ' + possessive + ' song profile …') : tr('Wir ordnen gerade dein Songprofil …', 'We are arranging your song profile …');
      if (emailTitle) emailTitle.textContent = state.recipientName ? tr(possessive + ' Song kann starten.', possessive + ' song can begin.') : tr('Dein Song kann starten.', 'Your song can begin.');
      if (offerTitle) offerTitle.textContent = state.recipientName ? tr('Dein persönlicher Song für ' + state.recipientName + '.', 'Your personal song for ' + state.recipientName + '.') : tr('Dein persönlicher Song.', 'Your personal song.');
      root.querySelectorAll('[data-offer-recipient]').forEach(function (node) { node.textContent = state.recipientName || tr('deine besondere Person', 'your special person'); });
      root.querySelectorAll('[data-offer-genre]').forEach(function (node) { node.textContent = state.genre === 'Andere Musikrichtung' && state.genreOther.trim() ? state.genreOther.trim() : localizedLabel(state.genre || tr('wird passend gewählt', 'chosen to fit')); });
      root.querySelectorAll('[data-offer-occasion]').forEach(function (node) { node.textContent = state.occasion === 'Ein anderer Anlass' && state.occasionOther.trim() ? state.occasionOther.trim() : localizedLabel(state.occasion || tr('euer Moment', 'your moment')); });
      var offerMeta=root.querySelector('[data-mg-offer-meta]'); if(offerMeta)offerMeta.textContent=[state.occasion?(state.occasionOther||localizedLabel(state.occasion)):'',state.genre?(state.genreOther||localizedLabel(state.genre)):''].filter(Boolean).join(' · ');
      var contextAudio = root.querySelector('[data-mg-context-audio]');
      if(contextAudio){
        var genreButtons=Array.from(root.querySelectorAll('[data-choice="genre"]'));
        var selectedGenre=genreButtons.find(function(button){return button.dataset.value===state.genre;});
        var source=selectedGenre && selectedGenre.parentElement.querySelector('audio source');
        var contextLabel=root.querySelector('[data-mg-context-label]');
        if(!source){var defaultGenre=genreButtons.find(function(button){return button.dataset.value==='Pop';});source=defaultGenre&&defaultGenre.parentElement.querySelector('audio source');}
        if(source && contextAudio.querySelector('source').getAttribute('src')!==source.getAttribute('src')){contextAudio.pause();contextAudio.querySelector('source').src=source.getAttribute('src');contextAudio.load();}
        if(contextLabel)contextLabel.textContent=selectedGenre&&selectedGenre.parentElement.querySelector('audio')?tr('Hörbeispiel: ','Style example: ')+localizedLabel(state.genre):tr('Ein Beispiel aus unserem Angebot','An example from our collection');
      }
      if (offerEmail) {
        offerEmail.textContent = state.email || tr('E-Mail aus deinem gespeicherten Songprofil','Email from your saved song profile');
        if (offerEmail.parentElement) offerEmail.parentElement.hidden = false;
      }
      root.querySelectorAll('[data-mg-lyric-name]').forEach(function (node) { node.textContent = state.recipientName || tr('du', 'you'); });
    }

    function christmasSeasonActive() {
      // One-off 2026 season, boundaries in Europe/Berlin (including DST).
      var now = Date.now();
      return now >= Date.parse('2026-09-14T00:00:00+02:00') && now < Date.parse('2026-12-28T00:00:00+01:00');
    }

    function syncChristmasOccasion() {
      var choice = root.querySelector('[data-mg-christmas]');
      // Keep an existing customer's choice visible when resuming after the season.
      if (choice) choice.hidden = !christmasSeasonActive() && state.occasion !== 'Weihnachten';
      var guide = root.querySelector('.mg-story-guide');
      if (guide) guide.textContent = state.occasion === 'Weihnachten'
        ? tr('Was macht diesen Menschen besonders – und was möchtest du ihm zu Weihnachten sagen? Stichpunkte reichen.', 'What makes this person special – and what would you like to tell them at Christmas? Short notes are enough.')
        : tr('Ein leichter Einstieg: eine gemeinsame Erinnerung, ein typischer Satz von euch und das, was du sagen möchtest. Stichpunkte reichen.', 'Need a starting point? Think of one memory, a phrase you share, and what you want to say. Short notes are enough.');
    }

    function syncAllFields() {
      syncChristmasOccasion();
      renderConnectionOptions(); renderPeople(); syncChoices(); syncFields(); syncConditionals();
    }

    function prepareTurnstile() {
      if (root.dataset.turnstileEnabled !== 'true' || window.turnstile) return;
      if (document.querySelector('script[src*="challenges.cloudflare.com/turnstile/v0/api.js"]')) return;
      var script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
      script.async = true;
      script.addEventListener('error', function () { script.remove(); root.dataset.turnstileFailed = 'true'; });
      document.head.appendChild(script);
    }
    window.mgTurnstileError = function () {
      document.querySelectorAll('[data-mg-configurator]').forEach(function (node) { node.dataset.turnstileFailed = 'true'; });
      return true;
    };
    window.mgTurnstileSuccess = function () {
      document.querySelectorAll('[data-mg-configurator]').forEach(function (node) { delete node.dataset.turnstileFailed; });
    };
    async function waitForTurnstileToken(maxMs) {
      var until = Date.now() + maxMs;
      while (Date.now() < until && root.dataset.turnstileFailed !== 'true') {
        var field = root.querySelector('[name="cf-turnstile-response"]');
        var token = field ? String(field.value || '').trim() : '';
        if (token) return token;
        await new Promise(function (resolve) { window.setTimeout(resolve, 200); });
      }
      return '';
    }

    function showStep(id) {
      window.clearTimeout(autoAdvanceTimer);
      var outgoingPanel = root.querySelector('[data-step="' + currentId + '"]');
      if (outgoingPanel && currentId !== id) outgoingPanel.querySelectorAll('[data-mg-audio]').forEach(function (audio) { audio.pause(); });
      var groupedSteps = {names:'recipient', connection:'occasion', moods:'voice', language:'voice', senderIdentity:'details', pronunciation:'details', favoriteArtist:'details'};
      id = groupedSteps[id] || id;
      if (['genre', 'voice', 'details', 'gate'].indexOf(id) !== -1 && !savedConfigurationId) prepareTurnstile();
      var seq = sequence();
      if (briefingLocked && ['offer', 'success'].indexOf(id) === -1) id = 'offer';
      if (id === 'additionalPeople' && !isFamily()) id = 'proof';
      if (['summary', 'gate', 'loading', 'offer', 'success'].indexOf(id) === -1 && seq.indexOf(id) === -1) id = 'recipient';
      currentId = id;
      document.body.classList.toggle('mg-offer-open',id==='offer');
      root.querySelectorAll('[data-step]').forEach(function (panel) { panel.hidden = panel.dataset.step !== id; });
      var panel = root.querySelector('[data-step="' + id + '"]');
      var questions = questionIds();
      var totalSteps = questions.length + 1;
      var questionIndex = questions.indexOf(id);
      var completed = seq.slice(0, Math.max(0, seq.indexOf(id))).filter(function (stepId) { return questions.indexOf(stepId) !== -1; }).length;
      var completeScreen = ['summary', 'gate', 'loading', 'offer', 'success'].indexOf(id) !== -1;
      var percent = completeScreen ? (id === 'gate' ? 92 : 100) : Math.max(4, ((questionIndex >= 0 ? questionIndex + 1 : completed) / totalSteps) * 100);
      phaseLabel.textContent = completeScreen ? (id === 'success' ? tr('Fertig', 'Done') : tr('Freigabe', 'Review')) : (panel ? panel.dataset.phase : tr('Person', 'Person'));
      counterLabel.textContent = completeScreen
        ? (id === 'gate' ? tr('Schritt ' + totalSteps + ' · E‑Mail', 'Step ' + totalSteps + ' · Email') : tr('Songprofil vollständig', 'Song profile complete'))
        : (questionIndex >= 0
          ? tr('Schritt ' + (questionIndex + 1) + ' von ' + totalSteps, 'Step ' + (questionIndex + 1) + ' of ' + totalSteps)
          : tr('Schritt ' + completed + ' von ' + totalSteps, 'Step ' + completed + ' of ' + totalSteps));
      progressBar.style.width = percent + '%'; progressWrap.setAttribute('aria-valuenow', String(Math.round(percent)));
      if (id === 'summary') renderSummary();
      if (id === 'offer') { updateOfferTotal(); requestLyricPreview(); }
      syncAllFields(); syncNavigation(); syncBriefingLock(); setError(''); saveDraft();
      if (id === 'gate' && !savedConfigurationId && root.dataset.turnstileEnabled === 'true' && window.turnstile && typeof window.turnstile.reset === 'function') {
        try { window.turnstile.reset(); } catch (ignore) {}
      }
      if(id === 'gate')startAnonymousPreview();
      var heading = panel && panel.querySelector('h2[tabindex="-1"]'); if (heading) heading.focus({ preventScroll: true });
      // Jump (not glide) to the top of the new step, like a page change.
      scrollToElement(root, 'start', true);
      emit(root, id === 'summary' ? 'mg_summary_view' : 'mg_step_view', { section_id: root.dataset.sectionId || '', step_id: id, total_steps: totalSteps, path: pathName() });
    }

    function validationMessage(id) {
      if (id === 'recipient' && !state.recipientRole) return tr('Bitte wähle aus, für wen der Song bestimmt ist.', 'Please choose who the song is for.');
      if (id === 'occasion' && !state.occasion) return tr('Bitte wähle einen Anlass.', 'Please choose an occasion.');
      if (id === 'names' && !state.recipientName.trim()) return tr('Bitte gib den Namen der beschenkten Person ein.', 'Please enter the recipient’s name.');
      if (id === 'connection' && !state.connection) return tr('Bitte wähle aus, was eure Verbindung beschreibt.', 'Please choose what best describes your relationship.');
      if (id === 'language' && !state.language) return tr('Bitte wähle die Sprache des Songs.', 'Please choose the song language.');
      if (id === 'details' && state.lyricsMode === 'finishedLyrics' && !state.finishedLyrics.trim()) return tr('Bitte füge deinen Songtext ein oder wähle „Ich teile Stichpunkte“.', 'Please paste your lyrics or choose “I will share notes”.');
      return '';
    }

    function next() {
      var panel = root.querySelector('[data-step="' + currentId + '"]');
      if (!panel) return;
      if (currentId === 'genre' && !state.genre) state.genre = 'Ihr dürft entscheiden';
      if (currentId === 'voice' && !state.voice) state.voice = 'Ihr dürft entscheiden';
      if (panel.dataset.kind === 'question') {
        var groupChecks = {recipient:['recipient','names'],occasion:['occasion','connection'],genre:['genre'],voice:['voice','language','moods'],details:['details']};
        var failedKey = (groupChecks[currentId] || [currentId]).find(function (key) { return Boolean(validationMessage(key)); });
        if (failedKey) { setError(validationMessage(failedKey), failedKey === 'details' ? 'finishedLyrics' : failedKey); emit(root, 'mg_validation_error', { section_id: root.dataset.sectionId || '', step_id: currentId, total_steps: totalStepCount(), path: pathName() }); return; }
        // One gentle, non-blocking nudge: an empty story is the main cause of generic songs.
        if (currentId === 'details' && state.lyricsMode !== 'finishedLyrics' && state.keyMoments.trim().length < 20 && !detailsNudgeShown) {
          detailsNudgeShown = true;
          setError(tr('Schon ein, zwei Stichpunkte – ein Insider, ein Ort oder ein typischer Satz von euch – machen den Song deutlich persönlicher. Du kannst aber auch direkt weitergehen.', 'Just one or two notes – an inside joke, a place or a phrase you share – make the song much more personal. You can also continue right away.'), 'details', true);
          nextButton.textContent = tr('Ohne weitere Details weiter →', 'Continue without more details →');
          return;
        }
        emit(root, 'mg_step_complete', { section_id: root.dataset.sectionId || '', step_id: currentId, total_steps: totalStepCount(), path: pathName() });
      }
      var seq = sequence(); var index = seq.indexOf(currentId);
      if (index >= seq.length - 1) showStep('gate'); else showStep(seq[index + 1]);
    }

    function back() {
      if (briefingLocked) { setError(tr('Dein Briefing ist bereits gespeichert. Bitte schließe jetzt nur noch das Hinzufügen zum Warenkorb ab.', 'Your brief is already saved. Please complete only the remaining cart step.')); return; }
      if (currentId === 'gate') { var seqGate = sequence(); showStep(seqGate[seqGate.length - 1]); return; }
      if (currentId === 'summary') { var seqSummary = sequence(); showStep(seqSummary[seqSummary.length - 1]); return; }
      var seq = sequence(); var index = seq.indexOf(currentId);
      if (index <= 0) { showStep('recipient'); return; }
      showStep(seq[index - 1]);
    }

    function makeSummaryCard(title, lines) {
      var card = document.createElement('article'); card.className = 'mg-summary-card';
      var heading = document.createElement('h3'); heading.textContent = title; card.appendChild(heading);
      lines.filter(Boolean).forEach(function (line) { var p = document.createElement('p'); p.textContent = line; card.appendChild(p); });
      return card;
    }

    function recipientRoleLabel() {
      var labels = isEnglish ? {
        partner: 'Partner', child: 'Daughter / son', parent: 'Mother / father',
        sibling: 'Sister / brother', friend: 'Friend', grandparents: 'Grandparents', other: 'Another special person'
      } : {
        partner: 'Partnerin / Partner', child: 'Tochter / Sohn', parent: 'Mutter / Vater',
        sibling: 'Schwester / Bruder', friend: 'Freundin / Freund', grandparents: 'Großeltern', other: 'Andere besondere Person'
      };
      return state.recipientRole === 'other' && state.recipientRoleOther.trim()
        ? state.recipientRoleOther.trim()
        : labels[state.recipientRole] || '';
    }

    function renderSummary() {
      var summary = root.querySelector('[data-mg-summary]'); if (!summary) return; summary.textContent = '';
      var occasion = state.occasion === 'Ein anderer Anlass' ? state.occasionOther : localizedLabel(state.occasion);
      var connection = state.connection === 'Etwas anderes' ? state.connectionOther : localizedLabel(state.connection);
      var genre = state.genre === 'Andere Musikrichtung' && state.genreOther ? state.genreOther : localizedLabel(state.genre);
      var language = state.language === 'Andere Sprache' ? state.languageOther : localizedLabel(state.language);
      var traits = state.traits.filter(function (trait) { return trait !== 'Etwas Eigenes'; }).map(localizedLabel);
      if (state.traits.indexOf('Etwas Eigenes') !== -1 && state.customTrait.trim()) traits.push(state.customTrait.trim());
      summary.appendChild(makeSummaryCard(tr('Person & Anlass', 'Person & occasion'), [
        tr('Beschenkte Person: ', 'Recipient: ') + (state.recipientName || tr('Noch kein Name', 'No name yet')),
        recipientRoleLabel() ? tr('Beziehung: ', 'Relationship: ') + recipientRoleLabel() : '',
        state.senderNames ? tr('Absender: ', 'From: ') + state.senderNames : '',
        state.pronunciation ? tr('Aussprache: ', 'Pronunciation: ') + state.pronunciation : '',
        occasion ? tr('Anlass: ', 'Occasion: ') + occasion : '',
        connection ? tr('Verbindung: ', 'Connection: ') + connection : '',
        isFamily() && state.additionalPeople.filter(Boolean).length ? tr('Weitere Personen: ', 'Additional people: ') + state.additionalPeople.filter(Boolean).join(', ') : ''
      ]));
      summary.appendChild(makeSummaryCard(tr('Klang & Stimme', 'Sound & voice'), [
        state.genre ? tr('Musikrichtung: ', 'Musical style: ') + genre : '',
        state.moods.length ? tr('Stimmung: ', 'Mood: ') + state.moods.map(localizedLabel).join(', ') : '',
        state.voice ? tr('Stimme: ', 'Voice: ') + localizedLabel(state.voice) : '',
        state.perspective ? tr('Perspektive: ', 'Perspective: ') + localizedLabel(state.perspective) : '',
        language ? tr('Sprache: ', 'Language: ') + language : '',
        state.favoriteArtist ? tr('Musikalische Referenz: ', 'Musical reference: ') + state.favoriteArtist : ''
      ]));
      summary.appendChild(makeSummaryCard(tr('Eure Geschichte', 'Your story'), [
        state.storyOrigin ? tr('Der Anfang: ', 'The beginning: ') + state.storyOrigin : '',
        state.keyMoments ? tr('Wichtige Momente: ', 'Important moments: ') + state.keyMoments : '',
        traits.length ? tr('Eigenschaften: ', 'Traits: ') + traits.join(', ') : ''
      ]));
      summary.appendChild(makeSummaryCard(tr('Botschaft & Hinweise', 'Message & notes'), [
        state.coreMessage ? tr('Kernbotschaft: ', 'Core message: ') + state.coreMessage : '',
        state.mustInclude ? tr('Unbedingt erwähnen: ', 'Must include: ') + state.mustInclude : '',
        state.mustAvoid ? tr('Nicht erwähnen: ', 'Do not mention: ') + state.mustAvoid : '',
        state.additionalNotes ? tr('Weitere Hinweise: ', 'Additional notes: ') + state.additionalNotes : ''
      ]));
      var count = root.querySelector('[data-summary-count]'); if (count) count.textContent = isEnglish ? totalStepCount() + ' steps prepared' : totalStepCount() + ' Schritte vorbereitet';
    }

    function webhookPayload(variantId) {
      normalizeDependentState();
      return {
        schemaVersion: 'melodyglow-songprofile.v1',
        customerLocale: root.dataset.mgLocale === 'en' ? 'en' : 'de',
        request_id: requestId,
        path: pathName(),
        recipientRole: state.recipientRole,
        recipientRoleOther: state.recipientRole === 'other' ? state.recipientRoleOther : '',
        occasion: state.occasion,
        occasionOther: state.occasion === 'Ein anderer Anlass' ? state.occasionOther : '',
        recipientName: state.recipientName,
        senderNames: state.senderNames,
        pronunciation: state.pronunciation,
        connection: state.connection,
        connectionOther: state.connection === 'Etwas anderes' ? state.connectionOther : '',
        additionalPeople: isFamily() ? state.additionalPeople.filter(Boolean) : [],
        genre: state.genre,
        genreOther: state.genre === 'Andere Musikrichtung' ? state.genreOther : '',
        moods: state.moods,
        senderIdentity: state.senderIdentity,
        voice: state.voice,
        perspective: state.perspective,
        language: state.language,
        languageOther: state.language === 'Andere Sprache' ? state.languageOther : '',
        storyOrigin: state.storyOrigin,
        keyMoments: state.keyMoments,
        traits: state.traits,
        customTrait: state.traits.indexOf('Etwas Eigenes') !== -1 ? state.customTrait : '',
        coreMessage: state.coreMessage,
        mustInclude: state.mustInclude,
        mustAvoid: state.mustAvoid,
        additionalNotes: state.additionalNotes,
        favoriteArtist: state.favoriteArtist,
        lyricsMode: state.lyricsMode,
        finishedLyrics: state.lyricsMode === 'finishedLyrics' ? state.finishedLyrics : '',
        email: state.email,
        privacyNoticeShown: true,
        recoveryAccepted: state.recoveryAccepted === true,
        emailConsentVersion: state.recoveryAccepted === true ? 'email-personal-v1-2026-09-22' : null,
        shopifyOrderSyncRequested: true,
        shopifyOrderSyncTarget: 'admin_order_metafield',
        product_variant_id: String(variantId)
      };
    }

    function selectedVariantId() {
      if (savedConfigurationId && /^\d{6,20}$/.test(pendingVariantId)) return pendingVariantId;
      var configured = String(root.dataset.variantId || '').trim();
      if (root.dataset.allowQueryVariant === 'true') {
        var queryVariant = new URLSearchParams(window.location.search).get('variant');
        if (queryVariant && /^\d{6,20}$/.test(queryVariant)) configured = queryVariant;
      }
      return /^\d{6,20}$/.test(configured) ? configured : '';
    }

    async function loadCart(shopRoot) {
      var response = await fetchWithTimeout(shopRoot + 'cart.js', {
        method: 'GET', credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' }
      }, 15000);
      if (!response.ok) throw new Error('cart_check_failed');
      var cart = await response.json();
      if (!cart || !Array.isArray(cart.items)) throw new Error('cart_check_failed');
      return cart;
    }

    function configurationProperty(item) {
      var properties = item && item.properties && typeof item.properties === 'object' ? item.properties : {};
      return String(properties._configuration_id || '');
    }

    async function normalizeConfigurationInCart(shopRoot, configurationId, variantId) {
      var cart = await loadCart(shopRoot);
      var allMatches = cart.items.filter(function (item) { return configurationProperty(item) === configurationId; });
      if (!allMatches.length) return false;
      var exactMatches = allMatches.filter(function (item) { return String(item.variant_id || item.id || '') === String(variantId); });
      if (exactMatches.length !== allMatches.length || !exactMatches.length) throw new Error('cart_variant_conflict');
      for (var index = 0; index < exactMatches.length; index += 1) {
        var item = exactMatches[index];
        var desiredQuantity = index === 0 ? 1 : 0;
        if (Number(item.quantity) === desiredQuantity) continue;
        var change = await fetchWithTimeout(shopRoot + 'cart/change.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: desiredQuantity })
        }, 20000);
        if (!change.ok) throw new Error('cart_normalize_failed');
      }
      return true;
    }

    async function ensureConfigurationInCart(shopRoot, variantId, configurationId) {
      if (await normalizeConfigurationInCart(shopRoot, configurationId, variantId)) return true;
      if (cartAttemptedAt && Date.now() - cartAttemptedAt < 60000) throw new Error('cart_state_pending');
      cartAttemptedAt = Date.now();
      savePendingCart();
      var cartResponse;
      try {
        cartResponse = await fetchWithTimeout(shopRoot + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { '_configuration_id': configurationId } }] })
        }, 20000);
      } catch (error) {
        try {
          if (await normalizeConfigurationInCart(shopRoot, configurationId, variantId)) return true;
        } catch (recoveryError) {
          if (recoveryError && recoveryError.message === 'cart_variant_conflict') throw recoveryError;
        }
        throw new Error('cart_add_uncertain');
      }
      if (!cartResponse.ok) {
        var status = Number(cartResponse.status || 0);
        var definitiveClientFailure = status >= 400 && status < 500 && [408, 425, 429].indexOf(status) === -1;
        if (definitiveClientFailure) {
          cartAttemptedAt = 0;
          savePendingCart();
          throw new Error('cart_add_failed');
        }
        try {
          if (await normalizeConfigurationInCart(shopRoot, configurationId, variantId)) return true;
        } catch (recoveryError) {
          if (recoveryError && recoveryError.message === 'cart_variant_conflict') throw recoveryError;
        }
        throw new Error('cart_add_uncertain');
      }
      return true;
    }

    function selectedOfferAddons() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-mg-addon]:checked')).map(function (input) {
        return { id: String(input.value || ''), cents: Number(input.dataset.priceCents || 0) };
      }).filter(function (addon) { return /^\d{6,20}$/.test(addon.id); });
    }

    function updateOfferDelivery() {
      var expressSelected = Boolean(root.querySelector('[data-mg-express-addon]:checked'));
      var hours = expressSelected
        ? Math.max(1, Number(root.dataset.expressDeliveryHours || 2))
        : Math.max(1, Number(root.dataset.standardDeliveryHours || 24));
      var label = expressSelected ? tr('Mit Express voraussichtlich per E-Mail bis', 'With express, expected by email by') : tr('Voraussichtlich per E-Mail bis', 'Expected by email by');
      root.querySelectorAll('[data-mg-offer-delivery-label]').forEach(function (node) { node.textContent = label; });
      root.querySelectorAll('[data-mg-offer-delivery-time]').forEach(function (node) { node.textContent = formatReadyAt(node, hours); });
    }

    function updateOfferTotal() {
  updateOfferDelivery();
  var addons=selectedOfferAddons(),total=Number(root.dataset.basePriceCents||0);
  addons.forEach(function(addon){total+=addon.cents;});
  var valid=validOfferPrice();
  total-=activeCreditCents();renderOfferSavings();
  var formatted=valid?money(total):'—';
  root.querySelectorAll('[data-mg-offer-total]').forEach(function(n){n.textContent=formatted;});
  var count=root.querySelector('[data-mg-extras-count]');if(count)count.textContent=addons.length?'('+addons.length+tr(' gewählt)',' selected)'):'';
  var shipping=root.querySelector('[data-mg-physical-delivery]');if(shipping)shipping.hidden=!root.querySelector('[data-mg-addon-kind="acrylic"]:checked');
  checkoutButtons.forEach(function(button){button.disabled=submitInFlight||!savedConfigurationId||!valid;});
  savePendingCart();syncOfferSticky();
}


    function addonConfigurationProperty(item) {
      var properties = item && item.properties && typeof item.properties === 'object' ? item.properties : {};
      return String(properties._melodyglow_addon_for || '');
    }

    async function retainCurrentConfigurationInCart(shopRoot, configurationId, variantId) {
      var selectedIds = selectedOfferAddons().map(function (addon) { return addon.id; });
      function verifyCurrent(cart) {
        var songs = cart.items.filter(function (item) { return configurationProperty(item) === configurationId; });
        var extras = cart.items.filter(function (item) { return addonConfigurationProperty(item) === configurationId; });
        if (songs.length !== 1 || String(songs[0].variant_id || songs[0].id) !== String(variantId) || Number(songs[0].quantity) !== 1 ||
            extras.length !== selectedIds.length || selectedIds.some(function (id) {
              var matches = extras.filter(function (item) { return String(item.variant_id || item.id) === id; });
              return matches.length !== 1 || Number(matches[0].quantity) !== 1;
            })) throw new Error('cart_replace_failed');
      }
      function isPrevious(item) {
        var owner = configurationProperty(item) || addonConfigurationProperty(item);
        return /^mg_[0-9a-f]{32}$/.test(owner) && owner !== configurationId;
      }
      var cart = await loadCart(shopRoot);
      // Never remove a previous song before its replacement and all extras exist.
      verifyCurrent(cart);
      var previous = cart.items.filter(isPrevious);
      if (previous.length) {
        var updates = {};
        previous.forEach(function (item) {
          if (!item.key) throw new Error('cart_replace_failed');
          updates[item.key] = 0;
        });
        var response = await fetchWithTimeout(shopRoot + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }, 20000);
        if (!response.ok) throw new Error('cart_replace_failed');
      }
      var verified = await loadCart(shopRoot);
      verifyCurrent(verified);
      if (verified.items.some(isPrevious)) throw new Error('cart_replace_failed');
    }

    async function syncOfferExtrasInCart(shopRoot, configurationId) {
      var selected = selectedOfferAddons();
      var selectedIds = selected.map(function (addon) { return addon.id; });
      var cart = await loadCart(shopRoot);
      var associated = cart.items.filter(function (item) { return addonConfigurationProperty(item) === configurationId; });
      var seen = {};
      for (var index = 0; index < associated.length; index += 1) {
        var item = associated[index];
        var itemId = String(item.variant_id || item.id || '');
        var keep = selectedIds.indexOf(itemId) !== -1 && !seen[itemId];
        seen[itemId] = keep || seen[itemId];
        if (keep && Number(item.quantity) === 1) continue;
        var change = await fetchWithTimeout(shopRoot + 'cart/change.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: keep ? 1 : 0 })
        }, 20000);
        if (!change.ok) throw new Error('addon_sync_failed');
      }
      var missing = selected.filter(function (addon) { return !seen[addon.id]; });
      if (missing.length) {
        var response = await fetchWithTimeout(shopRoot + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: missing.map(function (addon) { return { id: addon.id, quantity: 1, properties: { '_melodyglow_addon_for': configurationId } }; }) })
        }, 20000);
        if (!response.ok) throw new Error('addon_sync_failed');
      }
    }

    async function removeConfigurationFromCart(shopRoot, configurationId) {
      var cart = await loadCart(shopRoot);
       var matches = cart.items.filter(function (item) { return configurationProperty(item) === configurationId || addonConfigurationProperty(item) === configurationId; });
      for (var index = 0; index < matches.length; index += 1) {
        var change = await fetchWithTimeout(shopRoot + 'cart/change.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: matches[index].key, quantity: 0 })
        }, 20000);
        if (!change.ok) throw new Error('cart_discard_failed');
      }
      var verified = await loadCart(shopRoot);
       if (verified.items.some(function (item) { return configurationProperty(item) === configurationId || addonConfigurationProperty(item) === configurationId; })) throw new Error('cart_discard_failed');
    }

    async function submit() {
      if (submitInFlight || anonymousSubmitWaiting) return;
      if(savedConfigurationId && !validOfferPrice()){setError(tr('Der Preis konnte nicht geladen werden. Bitte lade die Seite erneut.','The price could not be loaded. Please reload this page.'));return;}
      var anonymousReceiptForIntake=null;
      if(!savedConfigurationId && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.email)) {
        anonymousSubmitWaiting=true; submitButton.disabled=true;
        var beforeLabel=submitButton.innerHTML;
        if(anonymousPreviewPromise)submitButton.textContent=tr('Deine Vorschau wird vorbereitet …','Preparing your preview …');
        try { anonymousReceiptForIntake=await finishAnonymousPreview(); }
        finally { anonymousSubmitWaiting=false; submitButton.disabled=false; submitButton.innerHTML=beforeLabel; }
      }
      var activeSubmitButton = savedConfigurationId && checkoutButton ? checkoutButton : submitButton;
      if (!savedConfigurationId) prepareTurnstile();
      var turnstileRequired = root.dataset.turnstileEnabled === 'true';
      var turnstileField = root.querySelector('[name="cf-turnstile-response"]');
      var turnstileToken = turnstileField ? String(turnstileField.value || '').trim() : '';
      if (!savedConfigurationId) {
        var emailOkay = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.email);
        if (!emailOkay) { setError(tr('Bitte prüfe deine E-Mail-Adresse.', 'Please check your email address.')); var emailField = root.querySelector('[data-field="email"]'); if (emailField) { emailField.setAttribute('aria-invalid', 'true'); emailField.focus(); } return; }
        // The invisible check usually finishes within a few seconds; wait briefly instead of failing right away.
        if (turnstileRequired && !turnstileToken && !anonymousReceiptForIntake) {
          // A failed check gets a fresh attempt on the next click (only if the Turnstile script is there at all).
          if (root.dataset.turnstileFailed === 'true' && window.turnstile) { delete root.dataset.turnstileFailed; resetTurnstile(); }
          anonymousSubmitWaiting = true; submitButton.disabled = true; submitButton.textContent = tr('Kurze Sicherheitsprüfung …', 'Quick security check …');
          try { turnstileToken = await waitForTurnstileToken(6000); }
          finally { anonymousSubmitWaiting = false; submitButton.disabled = false; submitButton.innerHTML = submitButtonMarkup; }
        }
        if (turnstileRequired && !turnstileToken && !anonymousReceiptForIntake) {
          setError(root.dataset.turnstileFailed === 'true'
            ? tr('Die Sicherheitsprüfung hat gerade nicht geklappt. Tippe bitte noch einmal auf den Button. Klappt es wieder nicht, deaktiviere kurz deinen Werbeblocker oder öffne die Seite in einem anderen Browser – deine Angaben bleiben gespeichert.', 'The security check did not work just now. Please tap the button again. If it still fails, pause your ad blocker briefly or open this page in another browser – your answers stay saved.')
            : tr('Bitte schließe zuerst die Sicherheitsprüfung ab.', 'Please complete the security check first.'));
          return;
        }
      }
      var webhook = String(root.dataset.webhookUrl || '').trim();
      var variantId = selectedVariantId();
      if (!/^https:\/\//i.test(webhook)) { setError(tr('Der Cloudflare Intake-Endpunkt ist im Theme-Editor noch nicht als HTTPS-URL hinterlegt.', 'The Cloudflare intake endpoint has not yet been configured as an HTTPS URL in the theme editor.')); return; }
      if (!variantId) { setError(tr('Bitte verknüpfe im Theme-Editor ein Song-Produkt oder trage eine gültige Variant-ID ein.', 'Please connect a song product in the theme editor or enter a valid variant ID.')); return; }
      submitInFlight = true; checkoutButtons.forEach(function (button) { button.disabled = true; }); activeSubmitButton.disabled = true; activeSubmitButton.textContent = savedConfigurationId ? tr('Warenkorb wird vorbereitet …', 'Preparing your cart …') : tr('Songprofil wird geschützt gespeichert …', 'Saving your song profile securely …'); syncBriefingLock(); setError('');
      var loadingStarted = Date.now();
      if (!savedConfigurationId) showStep('loading');
      emit(root, 'mg_submit_attempt', { section_id: root.dataset.sectionId || '', step_id: 'gate', total_steps: totalStepCount(), path: pathName() });
      try {
        if (!savedConfigurationId) {
          intakeAttempted = true;
          saveDraft();
          var intakeHeaders = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
          if (turnstileToken) intakeHeaders['CF-Turnstile-Response'] = turnstileToken;
          var submittedMetaEmail = state.email;
          var response = await fetchWithTimeout(webhook, { method: 'POST', mode: 'cors', credentials: 'omit', headers: intakeHeaders, body: JSON.stringify(Object.assign(webhookPayload(variantId), anonymousReceiptForIntake ? {anonymous_preview:anonymousReceiptForIntake} : {})) }, 30000);
          if (!response.ok) {
            var failure = {};
            try { failure = await response.json(); } catch (ignore) {}
            if (failure && failure.code === 'IDEMPOTENCY_CONFLICT') {
              requestId = makeRequestId(); intakeAttempted = false; saveDraft(); resetTurnstile();
              throw new Error('idempotency_conflict');
            }
            throw new Error(failure && failure.code === 'BOT_CHECK_FAILED' ? 'bot_check_failed' : 'briefing_save_failed');
          }
          var responseData = await response.json();
          var result = responseData.result || responseData.data || responseData;
          if (result.persisted !== true || result.ready_for_cart !== true) throw new Error('briefing_not_ready_for_cart');
          if (result.request_id !== requestId) throw new Error('request_id_mismatch');
          var candidate = result.configuration_id || '';
          if (!/^mg_[0-9a-f]{32}$/.test(String(candidate))) throw new Error('invalid_configuration_id');
          lyricPreviewAccess = result.lyric_preview_access || null;
          savedConfigurationId = String(candidate);
          pendingVariantId = variantId;
          emit(root, "mg_lead_saved", {email: submittedMetaEmail});
          savePendingCart();
          setBriefingLocked(true);
          requestLyricPreview();
          await new Promise(function (resolve) { window.setTimeout(resolve, Math.max(0, 1800 - (Date.now() - loadingStarted))); });
          showStep('offer');
          return;
        }
        var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        await ensureConfigurationInCart(shopRoot, variantId, savedConfigurationId);
        await syncOfferExtrasInCart(shopRoot, savedConfigurationId);
        await retainCurrentConfigurationInCart(shopRoot, savedConfigurationId, variantId);
        clearPendingCart();
        if (draftEnabled) {
          try { window.localStorage.removeItem(draftKey); } catch (ignore) {}
        }
        emit(root, 'mg_intake_saved', { section_id: root.dataset.sectionId || '', step_id: 'success', total_steps: totalStepCount(), path: pathName() });
        var action = root.dataset.successAction || 'stay';
        if (action === 'cart') { window.location.assign(root.dataset.cartUrl || '/cart'); return; }
        if (action === 'checkout') { window.location.assign(shopRoot + 'checkout?skip_shop_pay=true' + (activeCreditCents() ? '&discount=' + encodeURIComponent(verifiedRecoveryCredit.code) : '')); return; }
        showStep('success');
      } catch (error) {
        if (!savedConfigurationId && turnstileRequired && window.turnstile && typeof window.turnstile.reset === 'function') {
          try { window.turnstile.reset(); } catch (ignore) {}
        }
        var message = error && error.message === 'cart_add_failed'
          ? tr('Dein Briefing ist gespeichert, aber die gewählte Produktvariante ist gerade nicht verfügbar. Du kannst den Warenkorb-Schritt erneut versuchen oder diesen Versuch verwerfen und neu beginnen.', 'Your brief is saved, but the selected product variant is currently unavailable. You can retry the cart step or discard this attempt and start again.')
          : error && ['cart_check_failed', 'cart_normalize_failed', 'addon_sync_failed', 'cart_replace_failed'].indexOf(error.message) !== -1
            ? tr('Dein Briefing ist gespeichert, aber der Warenkorb war kurz nicht erreichbar. Deine Angaben sind jetzt gesperrt; bitte klicke erneut, um nur den Warenkorb-Schritt zu wiederholen.', 'Your brief is saved, but the cart was temporarily unavailable. Your details are now locked; click again to repeat only the cart step.')
          : error && ['cart_add_uncertain', 'cart_state_pending'].indexOf(error.message) !== -1
            ? tr('Der Warenkorb wird möglicherweise noch verarbeitet. Bitte warte kurz und klicke erneut; vor einem weiteren Hinzufügen prüfen wir zuerst die vorhandene Konfigurations-ID.', 'The cart may still be processing. Wait a moment and click again; before adding anything else, we first check the existing configuration ID.')
          : error && error.message === 'cart_variant_conflict'
            ? tr('Diese Konfigurations-ID liegt bereits mit einer anderen Produktvariante im Warenkorb. Bitte entferne diese Position im Warenkorb und versuche es danach erneut.', 'This configuration ID is already in the cart with a different product variant. Remove that item from the cart and then try again.')
          : error && error.message === 'bot_check_failed'
            ? tr('Die Sicherheitsprüfung ist abgelaufen. Bitte bestätige sie erneut und versuche es noch einmal.', 'The security check has expired. Complete it again and retry.')
            : error && error.message === 'idempotency_conflict'
              ? tr('Deine Antworten haben sich nach einem früheren Speicherversuch geändert. Wir haben eine neue technische Anfrage vorbereitet; bitte bestätige die Sicherheitsprüfung erneut und klicke noch einmal.', 'Your answers changed after an earlier save attempt. We prepared a new request; complete the security check again and click once more.')
              : tr('Deine Antworten sind noch da. Die Verbindung hat gerade nicht mitgespielt – bitte versuche es erneut.', 'Your answers are still here. The connection did not work just now – please try again.');
        if (!savedConfigurationId) showStep('gate');
        setError(message);
      } finally {
        submitInFlight = false;
        if (submitButton) { submitButton.disabled = false; submitButton.innerHTML = submitButtonMarkup; }
      checkoutButtons.forEach(function (button) { button.disabled = false; button.textContent = button.hasAttribute('data-mg-checkout-sticky')?tr('Zur Kasse →','Checkout →'):tr('Weiter zur sicheren Kasse →', 'Continue to secure checkout →'); });
        syncBriefingLock();
      }
    }

    // After an answer, bring the next question of the same step into view (mainly for phones).
    var REVEAL_AFTER = { recipientRole: '[data-mg-question="names"]', occasion: '[data-mg-question="connection"]', voice: '[data-mg-question="language"]', connection: '[data-mg-nav]', language: '[data-mg-nav]' };
    function revealAfterChoice(key, value) {
      var conditional = root.querySelector('[data-show-when="' + key + ':' + value + '"]');
      var target = conditional && !conditional.hidden ? conditional : (REVEAL_AFTER[key] ? root.querySelector(REVEAL_AFTER[key]) : null);
      if (!target || target.offsetParent === null) return;
      window.setTimeout(function () {
        var viewport = window.innerHeight || document.documentElement.clientHeight;
        var rect = target.getBoundingClientRect();
        if (rect.top > viewport * 0.62) scrollToElement(target, target.matches('[data-mg-nav]') ? 'nearest' : 'center');
      }, 160);
    }

    form.addEventListener('submit', function (event) { event.preventDefault(); });
    root.addEventListener('keydown', function (event) {
      // Enter in a single-line answer moves on, like in any other form. Not on the email step,
      // where the buttons carry different consent choices.
      if (event.key !== 'Enter' || event.isComposing || !event.target.matches || !event.target.matches('input.mg-field')) return;
      if (['gate', 'loading', 'offer', 'success'].indexOf(currentId) !== -1) return;
      event.preventDefault();
      if (!nextButton.hidden && !briefingLocked) next();
    });
    root.addEventListener('click', function (event) {
      var storyPrompt = event.target.closest('[data-mg-story-prompt]');
      if (storyPrompt && root.contains(storyPrompt)) {
        if (!markBriefingChanged()) return;
        var storyField = root.querySelector('[data-field="keyMoments"]');
        if (!storyField) return;
        var addition = storyPrompt.dataset.mgStoryPrompt.replace('{name}', state.recipientName.trim() || tr('dir', 'you'));
        var existing = storyField.value.replace(/\s+$/, '');
        storyField.value = ((existing ? existing + '\n' : '') + addition + ' ').slice(0, 5000);
        state.keyMoments = storyField.value;
        syncFields(); saveDraft(); setError('');
        try { storyField.focus(); storyField.setSelectionRange(storyField.value.length, storyField.value.length); } catch (ignore) {}
        return;
      }
      var choice = event.target.closest('[data-choice]');
      if (choice && root.contains(choice)) {
        if (choice.hasAttribute('data-mg-christmas') && !christmasSeasonActive() && state.occasion !== 'Weihnachten') {
          syncChristmasOccasion(); return;
        }
        var choiceStep = currentId;
        if (!markBriefingChanged()) return;
        state[choice.dataset.choice] = choice.dataset.value; setError('');
        if (choice.dataset.choice === 'recipientRole') {
          state.connection = ''; state.connectionOther = '';
          if (state.recipientRole !== 'other') state.recipientRoleOther = '';
          if (!isFamily()) state.additionalPeople = [];
        }
        if (choice.dataset.choice === 'occasion' && state.occasion !== 'Ein anderer Anlass') state.occasionOther = '';
        if (choice.dataset.choice === 'connection' && state.connection !== 'Etwas anderes') state.connectionOther = '';
        if (choice.dataset.choice === 'genre' && state.genre !== 'Andere Musikrichtung') state.genreOther = '';
        if (choice.dataset.choice === 'language' && state.language !== 'Andere Sprache') state.languageOther = '';
        syncAllFields(); saveDraft(); emit(root, 'mg_answer_select', { section_id: root.dataset.sectionId || '', step_id: choiceStep, total_steps: totalStepCount(), path: pathName() }); scheduleAutomaticAdvance(choiceStep); revealAfterChoice(choice.dataset.choice, choice.dataset.value); return;
      }
      var multi = event.target.closest('[data-multi]');
      if (multi && root.contains(multi)) {
        if (!markBriefingChanged()) return;
        var key = multi.dataset.multi; var list = state[key] || []; var value = multi.dataset.value; var index = list.indexOf(value); var max = Number(multi.dataset.max || 99);
        if (index >= 0) list = list.filter(function (item) { return item !== value; }); else if (list.length < max) list = list.concat(value);
        if (key === 'traits' && list.indexOf('Etwas Eigenes') === -1) state.customTrait = '';
        state[key] = list; setError(''); syncAllFields(); saveDraft(); emit(root, 'mg_answer_select', { section_id: root.dataset.sectionId || '', step_id: currentId, total_steps: totalStepCount(), path: pathName() }); return;
      }
      var remove = event.target.closest('[data-remove-person]');
      if (remove && root.contains(remove)) { if (!markBriefingChanged()) return; state.additionalPeople.splice(Number(remove.dataset.removePerson), 1); renderPeople(); saveDraft(); return; }
    });
    root.addEventListener('input', function (event) {
      var field = event.target.closest('[data-field]');
      if (field) { if (!markBriefingChanged()) return; state[field.dataset.field] = field.type === 'checkbox' ? field.checked : field.value; syncFields(); syncConditionals(); saveDraft(); setError(''); return; }
      var person = event.target.closest('[data-person-index]');
      if (person) { if (!markBriefingChanged()) return; state.additionalPeople[Number(person.dataset.personIndex)] = person.value; saveDraft(); }
    });
    root.addEventListener('change', function (event) {
      var field = event.target.closest('[data-field]');
      if (field && field.type === 'checkbox') { if (!markBriefingChanged()) return; state[field.dataset.field] = field.checked; saveDraft(); setError(''); }
    });
    var addPersonButton = root.querySelector('[data-add-person]');
    if (addPersonButton) addPersonButton.addEventListener('click', function () { if (!markBriefingChanged()) return; if (state.additionalPeople.length < 4) { state.additionalPeople.push(''); renderPeople(); saveDraft(); } });
    startButton.addEventListener('click', function () { started = true; intro.hidden = true; flow.hidden = false; syncAllFields(); showStep(currentId); emit(root, 'mg_configurator_start', { section_id: root.dataset.sectionId || '', step_id: currentId, total_steps: totalStepCount(), path: pathName() }); });
    resetButton.addEventListener('click', function () { resetState(); startButton.textContent = tr('Songreise starten →', 'Start your song journey →'); resetButton.hidden = true; });
    jumpOfferButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var buybox = root.querySelector('[data-mg-order-overview]');
        if (!buybox) return;
        buybox.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        window.setTimeout(function () { try { buybox.focus({ preventScroll: true }); } catch (ignore) {} }, 450);
      });
    });
    editProfileButtons.forEach(function (button) {
      button.addEventListener('click', async function () {
        if (submitInFlight) return;
        if (cartAttemptedAt && Date.now() - cartAttemptedAt < 60000) {
          setError(tr('Der Warenkorb wird möglicherweise noch verarbeitet. Bitte warte kurz und versuche das Ändern danach erneut.', 'The cart may still be processing. Wait briefly, then try editing again.'));
          return;
        }
        submitInFlight = true;
        editProfileButtons.forEach(function (control) { control.disabled = true; });
        if (discardPendingButton) discardPendingButton.disabled = true;
        setError('');
        try {
          if (savedConfigurationId && cartAttemptedAt) {
            var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
            await removeConfigurationFromCart(shopRoot, savedConfigurationId);
          }
          lyricPreviewAccess = null; lyricPreviewActiveId = '';
          var oldPreview=root.querySelector('[data-mg-lyric-preview]'); if(oldPreview)oldPreview.remove();
          savedConfigurationId = '';
          pendingVariantId = '';
          requestId = makeRequestId();
          intakeAttempted = false;
          cartAttemptedAt = 0;
          clearPendingCart();
          resetTurnstile();
          setBriefingLocked(false);
          showStep('recipient');
          saveDraft();
        } catch (error) {
          setError(tr('Der Warenkorb konnte nicht sicher geprüft werden. Bitte versuche es später erneut; deine Angaben bleiben erhalten.', 'The cart could not be checked safely. Try again later; your details remain available.'));
        } finally {
          submitInFlight = false;
          editProfileButtons.forEach(function (control) { control.disabled = false; });
          syncBriefingLock();
        }
      });
    });
    if (discardPendingButton) discardPendingButton.addEventListener('click', async function () {
      if (submitInFlight) return;
      if (cartAttemptedAt && Date.now() - cartAttemptedAt < 60000) {
        setError(tr('Der Warenkorb wird möglicherweise noch verarbeitet. Bitte warte insgesamt 60 Sekunden ab; danach prüfen und entfernen wir die Position vor einem Neustart.', 'The cart may still be processing. Please wait a full 60 seconds; then we check and remove the item before restarting.'));
        return;
      }
      var confirmed = window.confirm(tr('Alle Angaben löschen und einen neuen Song beginnen?', 'Delete all details and start a new song?'));
      if (!confirmed) return;
      submitInFlight = true; submitButton.disabled = true; discardPendingButton.disabled = true; setError('');
      try {
        var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        if (savedConfigurationId && cartAttemptedAt) await removeConfigurationFromCart(shopRoot, savedConfigurationId);
        resetState(); resetTurnstile(); started = true; flow.hidden = false; intro.hidden = true; showStep('recipient');
        startButton.textContent = tr('Songreise starten →', 'Start your song journey →'); resetButton.hidden = true;
      } catch (error) {
        setError(tr('Der Warenkorb konnte nicht sicher geprüft und bereinigt werden. Bitte versuche es später erneut; dein gespeichertes Briefing bleibt bis dahin gesperrt.', 'The cart could not be checked and cleared safely. Please try again later; your saved brief remains locked until then.'));
      } finally {
        submitInFlight = false; submitButton.disabled = false; syncBriefingLock();
      }
    });
    nextButton.addEventListener('click', next); backButton.addEventListener('click', back);
    var toGateButton = root.querySelector('[data-mg-to-gate]');
    if (toGateButton) toGateButton.addEventListener('click', function () { showStep('gate'); });
    async function submitFromGate(wantsEmails) {
      if (submitInFlight || anonymousSubmitWaiting) return;
      if (!savedConfigurationId && state.recoveryAccepted !== wantsEmails) {
        if (!markBriefingChanged()) return;
        state.recoveryAccepted = wantsEmails;
      }
      if (offerOnlyButton) offerOnlyButton.disabled = true;
      try { await submit(); }
      finally { if (offerOnlyButton) offerOnlyButton.disabled = false; }
    }
    submitButton.addEventListener('click', function () { submitFromGate(true); });
    if (offerOnlyButton) offerOnlyButton.addEventListener('click', function () { submitFromGate(false); });
    checkoutButtons.forEach(function (button) { button.addEventListener('click', submit); });
    function validOfferPrice(){
      var base=Number(root.dataset.basePriceCents),addons=selectedOfferAddons();
      return Number.isSafeInteger(base)&&base>0&&addons.every(function(x){return Number.isSafeInteger(x.cents)&&x.cents>=0;});
    }
    var mainCheckoutVisible=false;
    function syncOfferSticky(){
      var bar=root.querySelector('[data-mg-offer-sticky]');if(!bar)return;
      var focused=document.activeElement;
      var typing=focused&&focused.matches('input,textarea,select,[contenteditable="true"]');
      var modal=Array.from(document.querySelectorAll('dialog[open],[role="dialog"],[aria-modal="true"]')).some(function(n){return n.getClientRects().length>0;});
      var keyboard=window.visualViewport&&window.visualViewport.height<window.innerHeight*0.75;
      var visible=currentId==='offer'&&offerPreviewStatus!=='loading'&&Boolean(savedConfigurationId)&&validOfferPrice()&&!mainCheckoutVisible&&!typing&&!modal&&!keyboard;
      if(bar.hidden===visible)bar.hidden=!visible;
      document.body.classList.toggle('mg-has-buybar',visible);
    }
    ['focusin','focusout','resize'].forEach(function(type){window.addEventListener(type,syncOfferSticky);});
    if(window.visualViewport)window.visualViewport.addEventListener('resize',syncOfferSticky);
    var offerObserver=new MutationObserver(syncOfferSticky);
    offerObserver.observe(root.querySelector('[data-step="offer"]'),{attributes:true,attributeFilter:['hidden']});
    var stickyGuardTimer=window.setInterval(function(){
      if(!root.isConnected){window.clearInterval(stickyGuardTimer);offerObserver.disconnect();return;}
      if(currentId==='offer')syncOfferSticky();
    },750);

    var offerSticky = root.querySelector('[data-mg-offer-sticky]');
    if(offerSticky && checkoutButton && window.IntersectionObserver)new IntersectionObserver(function(entries){mainCheckoutVisible=entries[0].isIntersecting;syncOfferSticky();},{threshold:0.2}).observe(checkoutButton);
    root.querySelectorAll('[data-mg-addon]').forEach(function (input) { input.addEventListener('change', updateOfferTotal); });

    if (!draftEnabled) {
      try { window.localStorage.removeItem(draftKey); } catch (ignore) {}
    }
    var draftFound = restoreDraft();
    var pendingCartFound = restorePendingCart();
    if (pendingCartFound) {
      startButton.textContent = tr('Gespeichertes Briefing zum Warenkorb hinzufügen →', 'Add saved brief to cart →');
      resetButton.hidden = true;
    } else if (draftFound) {
      startButton.textContent = tr('Entwurf fortsetzen →', 'Continue draft →'); resetButton.hidden = false;
    }
    // Links like ?fuer=mama&anlass=geburtstag (homepage cards, ads) pre-select answers that are still empty.
    function applyEntryParams() {
      var params = new URLSearchParams(window.location.search);
      function key(name, alias) { return String(params.get(name) || params.get(alias) || '').toLowerCase().replace(/ß/g, 'ss').replace(/[^a-z]/g, ''); }
      var roles = { partner: 'partner', partnerin: 'partner', liebe: 'partner', freund: 'friend', freundin: 'friend', friend: 'friend', kind: 'child', child: 'child', tochter: 'child', sohn: 'child', eltern: 'parent', mama: 'parent', papa: 'parent', mutter: 'parent', vater: 'parent', parent: 'parent', geschwister: 'sibling', schwester: 'sibling', bruder: 'sibling', sibling: 'sibling', grosseltern: 'grandparents', oma: 'grandparents', opa: 'grandparents', grandparents: 'grandparents' };
      var occasions = { weihnachten: 'Weihnachten', christmas: 'Weihnachten', geburtstag: 'Geburtstag', birthday: 'Geburtstag', hochzeit: 'Hochzeit oder Jahrestag', jahrestag: 'Hochzeit oder Jahrestag', wedding: 'Hochzeit oder Jahrestag', anniversary: 'Hochzeit oder Jahrestag', antrag: 'Heiratsantrag', heiratsantrag: 'Heiratsantrag', proposal: 'Heiratsantrag', geburt: 'Geburt oder Taufe', taufe: 'Geburt oder Taufe', danke: 'Danke sagen', thanks: 'Danke sagen', trost: 'Mut machen oder Trost schenken', mut: 'Mut machen oder Trost schenken', einfachso: 'Einfach so', justbecause: 'Einfach so' };
      var role = roles[key('fuer', 'for')];
      var occasion = occasions[key('anlass', 'occasion')];
      if (occasion === 'Weihnachten' && !christmasSeasonActive()) occasion = '';
      if (role && !state.recipientRole) state.recipientRole = role;
      if (occasion && !state.occasion) state.occasion = occasion;
    }
    if (!pendingCartFound) applyEntryParams();
    syncAllFields(); syncBriefingLock();
    async function restoreEmailOffer() {
      var fragment = window.location.hash.match(/^#mg-resume=(mg_[0-9a-f]{32})\.(\d{10})\.([A-Za-z0-9_-]{40,100})$/);
      if (!fragment && savedConfigurationId) { try { var previous=JSON.parse(window.sessionStorage.getItem(pendingCartKey+'-resume')||'null'); if(previous && previous[1]===savedConfigurationId && Number(previous[2])>Date.now()/1000) fragment=previous; } catch (_) {} }
      if (!fragment) return;
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
      submitInFlight = true;
      started = true; intro.hidden = true; flow.hidden = false; showStep('loading');
      try {
        var endpoint = new URL(String(root.dataset.webhookUrl || ''));
        endpoint.pathname = '/api/recovery/resume'; endpoint.search = ''; endpoint.hash = '';
        var response = await fetchWithTimeout(endpoint.toString(), { method: 'POST', mode: 'cors', credentials: 'omit', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ configuration_id: fragment[1], expires: Number(fragment[2]), signature: fragment[3] }) }, 30000);
        var result = await response.json();
        if (!response.ok || !result.ok || !result.profile) throw new Error(result.code || 'RECOVERY_UNAVAILABLE');
        verifiedRecoveryCredit=result.recovery_credit||null;
        try { window.sessionStorage.setItem(pendingCartKey+'-resume',JSON.stringify(fragment)); } catch (_) {}
        var profile = result.profile, freshState = initialState();
        Object.keys(freshState).forEach(function (key) { if (Object.prototype.hasOwnProperty.call(profile, key) && typeof freshState[key] === typeof profile[key] && Array.isArray(freshState[key]) === Array.isArray(profile[key])) freshState[key] = profile[key]; });
        lyricPreviewAccess = result.lyric_preview_access || null; lyricPreviewActiveId = "";
        state = freshState; requestId = profile.request_id; savedConfigurationId = result.configuration_id; pendingVariantId = String(profile.product_variant_id);
        if(verifiedRecoveryCredit){window.setTimeout(function(){if(currentId==='offer')updateOfferTotal();},Math.min(2147483647,Math.max(0,Date.parse(verifiedRecoveryCredit.expires_at)-Date.now()+100)));}
        intakeAttempted = true; cartAttemptedAt = 0; normalizeDependentState(); syncAllFields(); savePendingCart(); setBriefingLocked(true); showStep('offer');
      } catch (error) {
        showStep('recipient');
        setError(error.message === 'RECOVERY_ALREADY_PURCHASED' ? tr('Dieses Angebot wurde bereits bestellt. Bitte prüfe deine Bestellbestätigung.', 'This offer has already been purchased. Please check your order confirmation.') : tr('Dieser Angebotslink ist abgelaufen oder konnte nicht geladen werden. Du kannst hier einen neuen Song beginnen.', 'This offer link has expired or could not be loaded. You can start a new song here.'));
      } finally { submitInFlight = false; syncBriefingLock(); if (currentId === "offer") updateOfferTotal(); }
    }
    startButton.click(); restoreEmailOffer();

  }

  // Mobile: keep a "create your song" button in reach once the hero button has scrolled away.
  function initHome(root) {
    if (root.dataset.mgHomeReady === 'true') return;
    root.dataset.mgHomeReady = 'true';
    var bar = root.querySelector('[data-mg-home-sticky]');
    var heroActions = root.querySelector('.mg-hero .mg-actions');
    if (!bar || !heroActions || !window.IntersectionObserver) return;
    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      bar.querySelectorAll('a').forEach(function (link) { link.tabIndex = visible ? 0 : -1; });
    }).observe(heroActions);
  }

  function init(scope) {
    initAudios(scope);
    initDeliveryEstimates(scope);
    scope.querySelectorAll('[data-mg-home]').forEach(initHome);
    scope.querySelectorAll('[data-mg-product]').forEach(initProduct);
    scope.querySelectorAll('[data-mg-configurator]').forEach(initConfigurator);
    scope.querySelectorAll('[data-mg-cart-proof]').forEach(initCartProof);
  }

  window.MelodyGlowThemeRuntime = { init: init };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var audios = Array.prototype.slice.call(event.target.querySelectorAll('[data-mg-audio]'));
    if (event.target.matches && event.target.matches('[data-mg-audio]')) audios.push(event.target);
    audios.forEach(function (audio) { audio.pause(); audio.removeAttribute('data-mg-ready'); });
    var products = Array.prototype.slice.call(event.target.querySelectorAll('[data-mg-product]'));
    if (event.target.matches && event.target.matches('[data-mg-product]')) products.push(event.target);
    products.forEach(function (productRoot) { productRoot.removeAttribute('data-mg-product-ready'); });
    Array.prototype.slice.call(event.target.querySelectorAll('[data-mg-home]')).forEach(function (homeRoot) { homeRoot.removeAttribute('data-mg-home-ready'); });
    var configurators = Array.prototype.slice.call(event.target.querySelectorAll('[data-mg-configurator]'));
    if (event.target.matches && event.target.matches('[data-mg-configurator]')) configurators.push(event.target);
    configurators.forEach(function (configRoot) { configRoot.removeAttribute('data-mg-configurator-ready'); });
    var cartProofs = Array.prototype.slice.call(event.target.querySelectorAll('[data-mg-cart-proof]'));
    if (event.target.matches && event.target.matches('[data-mg-cart-proof]')) cartProofs.push(event.target);
    cartProofs.forEach(function (cartRoot) { cartRoot.removeAttribute('data-mg-cart-proof-ready'); });
  });
}());

(function () {
  'use strict';
  function initCampaigns() {
    document.querySelectorAll('[data-mg-campaign]').forEach(function (banner) {
      if (banner.dataset.initialized) return;
      banner.dataset.initialized = 'true';
      var start = Date.parse(banner.dataset.start), end = Date.parse(banner.dataset.end);
      // Fixed campaign window; never derive a new deadline from a visit or draft.
      if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start || end - start > 4 * 86400000 || banner.dataset.currency !== 'EUR') return;
      var en = banner.closest('[data-mg-configurator]').dataset.mgLocale === 'en';
      var time = banner.querySelector('[data-mg-campaign-end]');
      time.dateTime = new Date(end).toISOString();
      time.textContent = new Intl.DateTimeFormat(en ? 'en-GB' : 'de-DE', {timeZone:'Europe/Berlin',day:'2-digit',month:'2-digit',year:'numeric',hour:'2-digit',minute:'2-digit',timeZoneName:'short'}).format(new Date(end));
      var clock = banner.querySelector('[data-mg-campaign-clock]');
      function tick() {
        var now = Date.now();
        banner.hidden = now < start || now >= end;
        if (!banner.hidden) {
          var seconds = Math.ceil((end - now) / 1000);
          var days = Math.floor(seconds / 86400), hours = Math.floor(seconds % 86400 / 3600), minutes = Math.floor(seconds % 3600 / 60);
          clock.textContent = days + (en ? 'd ' : ' Tage ') + String(hours).padStart(2,'0') + 'h ' + String(minutes).padStart(2,'0') + 'm ' + String(seconds % 60).padStart(2,'0') + 's';
        }
        if (now >= end || !banner.isConnected) window.clearInterval(interval);
      }
      var interval = window.setInterval(tick, 1000);
      tick();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCampaigns); else initCampaigns();
  document.addEventListener('shopify:section:load', initCampaigns);
}());
